import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import { Textbox, Checkbox, Select as Select1 } from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  consultarCedulaFetch,
  setConsultaPlaca,
  setDatosPersona,
  limpiarDatosCotizacion2,
  coberturasFetch,
  AmparosAdicionalesFetch,
  FetchPorcentajeExtras,
  listarProvinciasComparadorFetch,
  listarParentescosFetch,
  setDatosPersonaAsegurado,
} from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import Select from "react-select";
import makeAnimated from "react-select/lib/animated";
import {
  FetchModificarCarrito,
  FetchGuardarDatosAdiconalesCarrito,
  FetchTotalesCabeceraCotizadores,
  FetchModificarCarritoRenovacion,
} from "../../redux/actions/ACarritoProductos";
import ValoresCotizacion from "./ValoresCotizacionRenovacion";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import { ambienteAplicacion, urlListarCiudades, urlListarRenovaciones, urlSubirArchivoS3, urlValidarChasis, urlValidarMotor } from "../../constants/urls";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import TablaCoberturasIndividual from "../TablaCoberturasIndividual/TablaCoberturasIndividualRenovacion";
import styles from "../TablaCoberturasIndividual/styles";
import { infoIds } from "../../constants";
import NumberFormat from "react-number-format";
import moment from "moment";
import { apiPost2 } from "../../api";
import { formatearNumero } from "../../redux/actions/aLogin";

class Cotizacion2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mostrarTablaCoberturas: false,
      renovacionActual: null,
      vehiculoActual: null,
      tieneErrorPrimaMinima: false,
      mensajeErrorPrimaMinima: '',
      primaMinima: 0.0,
      tipoDocumento: 1,
      archivoNoSiniestros: null,
      archivoNoSiniestrosBase64: '',
      errorArchivoNoSiniestros: false,
      urlArchivoNoSiniestros: '',

      tipoDocumentoAsegurado: 1,
      hasAvaluoError: true,
      fechaEmisionPasaporte: null,
      fechaCaducidadPasaporte: null,
      fechaIngresoPais: null,
      fechaEmisionPasaporteAsegurado: null,
      fechaCaducidadPasaporteAsegurado: null,
      fechaIngresoPaisAsegurado: null,
      planesComparador: this.props.planesComparador,
      placa: this.props.datosCotizacion.datosPlaca.placa,
      planComparadorSeleccionado: null,
      coberturasAdicionalesComparador: [],
      coberturasAdicionalesComparadorModificados: {},
      validate: false,
      validateAsegurado: false,
      mismosDatos: true,
      cargarParentescos: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca.chasis,
      motor: this.props.datosCotizacion.datosPlaca.motor,
      cedula: this.props.datosCotizacion.datosPersona.cedula,
      cedulaAsegurado: '',
      nombreAsegurado: '',

      celular: this.props.datosCotizacion.datosPersona.celular,
      celularAsegurado: '',
      marca: this.props.datosCotizacion.datosPlaca.marca,
      anio: this.props.datosCotizacion.datosPlaca.anio,
      modelo: this.props.datosCotizacion.datosPlaca.modelo,
      clase: this.props.datosCotizacion.datosPlaca.clase,
      tipo: this.props.datosCotizacion.datosPlaca.tipo,
      rastreo: false,
      nombre: this.props.datosCotizacion.datosPersona.nombre,
      fechaNacimiento: this.props.datosCotizacion.datosPersona.fechaNacimiento,
      fechaNacimientoAsegurado: new Date().toString("M/d/yyyy"),
      estadoCivil: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,
      estadoCivilAsegurado: null,
      parentesco: '0',
      genero: this.props.datosCotizacion.datosPersona.codigoGenero,
      generoAsegurado: null,
      territorioSeleccionado: "1",
      territorioSeleccionadoComparador: null,
      territorioSeleccionadoComparadorAsegurado: null,
      ciudadSeleccionada: null,
      ciudades: [],
      formEditado: false,
      valorAsegurado:
        this.props.datosCotizacion.datosPlaca.valor_avaluo === "" ||
          this.props.datosCotizacion.datosPlaca.valor_avaluo === undefined
          ? "18000"
          : this.props.datosCotizacion.datosPlaca.valor_avaluo,
      valorAseguradoOriginal:
        this.props.datosCotizacion.datosPlaca.valor_avaluo === "" ||
          this.props.datosCotizacion.datosPlaca.valor_avaluoOriginal === undefined
          ? "18000"
          : this.props.datosCotizacion.datosPlaca.valor_avaluoOriginal,
      arrayTerritorios: [],
      arrayTerritoriosComparador: [],
      accesoriosHabilitado: false,
      autoConcesionaria: this.props.datosCotizacion && this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.autoConcesionaria ? this.props.datosCotizacion.datosPlaca.autoConcesionaria : false,
      selectedOption:
        (this.props.datosCotizacion.datosPlaca.datosAccesorios === undefined ||
          this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios === undefined)
          ? null
          : this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios,
      selectedOptionOriginal:
        (this.props.datosCotizacion.datosPlaca.datosAccesorios === undefined ||
          this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios === undefined)
          ? null
          : this.props.datosCotizacion.datosPlaca.datosAccesorios.accesorios,
      selectedOptionColores:
        this.props.datosCotizacion.datosPlaca.reColorTxt === ""
          ? null
          : parseInt(this.props.datosCotizacion.datosPlaca.reColorTxt),
      valorAccesorios: "0",
      arrayAccesorios: [],
      arrayColores: [],
      hasValorAccesoriosError: true,
      cedulaError: "",
      cedulaAseguradoError: "",
      celularError: "",
      hasColorError: false,
      hasMotorError: true,
      hasChasisError: true,
      arrayTipos: [],
      tipoSeleccionado:
        this.props.datosCotizacion.datosPlaca.tipo === ""
          ? undefined
          : this.props.datosCotizacion.datosPlaca.tipo,
      hasTipoError: false,
      contadorCoberturas: 0,
      amparoGastosMedicosCheked: true,
      amparoAccidentesPersonalesCheked: true,
      amparoGastosTransporteCheked:
        this.props.datosCotizacion.datosPlaca
          .amparos &&
          this.props.datosCotizacion.datosPlaca
            .amparos.gastosTransporte
          ? this.props.datosCotizacion.datosPlaca.amparos.gastosTransporte
          : false,
      amparoPatrimonialCheked:
        this.props.datosCotizacion.datosPlaca.amparos &&
          this.props.datosCotizacion.datosPlaca.amparos
            .amparoPatrimonial
          ? this.props.datosCotizacion.datosPlaca.amparos.amparoPatrimonial
          : false,
      amparoObjetosOlvidadosCheked:
        this.props.datosCotizacion.datosPlaca
          .amparos &&
          this.props.datosCotizacion.datosPlaca
            .amparos.objetosOlvidados
          ? this.props.datosCotizacion.datosPlaca.amparos.objetosOlvidados
          : false,
      amparoGastosFunerariosCheked: this.props.datosCotizacion && this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.amparos && this.props.datosCotizacion.datosPlaca.amparos.gastosFunerarios
        ? this.props.datosCotizacion.datosPlaca.amparos.gastosFunerarios
        : false,
      amparoAutoSustitutoCheked: true,
      amparoLlaveProtegidaCheked: true,
      amparoDocumentosProtegidosCheked: true,
      capacidad: this.props.datosCotizacion.datosPlaca.capacidad,
      hasCapacidadError: true,
      arrayDeducibles: [],
      deducibleSelected: null,
      arrayRc: [],
      rcSelected: null,
      descSelected: 0,
      descuentos: [],
      verDeducibles: false,
      verRc: false,
      mostrarMensajeValidarEdad: false,
      mostrarMensajeValidarEdadAsegurado: false,

      codigoProductoEspecial: null,
      planes: [],
      planSeleccionado: null,
      openModal: false,
      chasisValido: true,
      motorValido: true,
      valorAseguradoValido: true,
      valorAseguradoRenovacionValido: true,
      valorAseguradoRenovacionValidoMensaje: '',
      renovacionSeleccionada: null,
      bloquearCarta: true,
    };
    this.validateForm = this.validateForm.bind(this);
    this.planTemplate = this.planTemplate.bind(this);
  }

  async componentDidMount() {





    console.log('datosPlacaVer', this.props.datosCotizacion)
    console.log('this.props.datosRenovaciones ', this.props.datosRenovaciones)
    window.scrollTo(0, 0);
    //console.log("INgreso Didmount");
    const queryParams = new URLSearchParams(this.props.location.search);
    let accion = queryParams.get("accion");
    const placa = queryParams.get("placa");

    let renovacion = await this.obtenerRenovacion()

    if (renovacion.transaccion) {

      var renovacionActual = renovacion.arrayrenovaciones[0]

      var vehiculoActual = renovacionActual.reDatosProducto.reDatosVehiculo.find(vehiculo => vehiculo.rePlaca == placa)

      var primaMinima = 0.00

      if (vehiculoActual) {


        this.setState({
          vehiculoActual: vehiculoActual,
        })
        primaMinima = vehiculoActual.rePrimaMinima ? parseFloat(vehiculoActual.rePrimaMinima) : 0.00
      }



      this.setState({
        renovacionActual: renovacionActual,
        primaMinima: primaMinima
      })
    }








    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial != null) {
      console.clear();
      console.log("codigoProductoEspecial", codigoProductoEspecial);
      this.setState({ codigoProductoEspecial: codigoProductoEspecial });
    } else {
      console.log("No codigoProductoEspecial");
    }


    this.props.limpiarDatosCotizacion();
    const {
      arrayDeducibles,
      deducibleSelected,
      arrayRc,
      rcSelected,
      descSelected,
      descuentos,
      verDeducibles,
      verRc,
    } = this.state;
    if (accion === "editar") {

      //   this.validarChasis(this.props.datosCotizacion.datosPlaca.chasis)
      //  this.validarMotor(this.props.datosCotizacion.datosPlaca.motor)

      let arrayProductos = this.props.dataProductoCarrito.productosCarrito
        .carProductos;
      let productoObtenido = arrayProductos.filter(
        (producto) => producto.datosProducto.placa === placa
      );

      console.log('productoObtenido', productoObtenido)

      const SucursalComparadorSeleccionado = this.props.dataProductoCarrito.productosCarrito.carDatosAsesor ? this.props.dataProductoCarrito.productosCarrito.carDatosAsesor.sucursalSeleccionada : null

      console.log('llegue1', this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente)

      if (this.props.dataProductoCarrito.productosCarrito && this.props.dataProductoCarrito.productosCarrito.carProductos && this.props.dataProductoCarrito.productosCarrito.carProductos[0] && this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente) {

        this.setState(
          {
            tipoDocumento: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.tipoDocumento,
            fechaEmisionPasaporte: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaEmisionPasaporte ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaEmisionPasaporte) : null,
            fechaCaducidadPasaporte: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaCaducidadPasaporte ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaCaducidadPasaporte) : null,
            fechaIngresoPais: this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaIngresoPais ? new Date(this.props.dataProductoCarrito.productosCarrito.carProductos[0].datosCliente.fechaIngresoPais) : null
          }
        )

      }

      await this.props.consultarProvincias(
        codigoProductoEspecial === "comparador" || codigoProductoEspecial === "pits" || codigoProductoEspecial === "externo" ? codigoProductoEspecial : "vehiculos",
        SucursalComparadorSeleccionado
      )


      productoObtenido = productoObtenido[0];

      if (productoObtenido && productoObtenido.datosAsegurado) {

        const datosAsegurado = productoObtenido.datosAsegurado

        this.setState({
          mismosDatos: true,
          cedulaAsegurado: datosAsegurado.cedula,
          nombreAsegurado: datosAsegurado.nombre,
          fechaNacimientoAsegurado: datosAsegurado && datosAsegurado.fechaNacimiento ? datosAsegurado.fechaNacimiento : new Date().toString("M/d/yyyy"),
          generoAsegurado: datosAsegurado.codigoGenero,
          estadoCivilAsegurado: datosAsegurado.codigoEstadoCivil,
          celularAsegurado: datosAsegurado.celular,
          territorioSeleccionadoComparadorAsegurado: datosAsegurado.provincia ? datosAsegurado.provincia : null
        })
        /*  if (datosAsegurado.provCodigoCore) {
           this.listarCiudades(datosAsegurado.provCodigoCore, datosAsegurado.ciudad ? datosAsegurado.ciudad : null)
         }
         if (datosAsegurado && datosAsegurado.mismosDatos) {
           await this.props.listarParentescos({ traerParentescoTitular: true });
         } else {
           this.props.listarParentescos({ traerParentescoTitular: false });
         }
 
         console.log('datosAsegurado', datosAsegurado) */

      } else {

        this.setState({
          mismosDatos: true
        })

      }

      if (productoObtenido && productoObtenido.datosCliente && productoObtenido.datosCliente.parCodigo) {



        this.setState({
          parentesco: productoObtenido.datosCliente.parCodigo,
        })


      }

      this.setState({
        placa: productoObtenido.datosProducto.placa,
        validate: false,
        hasPlacaError: true,
        chasis: productoObtenido.datosProducto.chasis,
        motor: productoObtenido.datosProducto.motor,
        cedula: productoObtenido.datosCliente.cedula,
        celular: productoObtenido.datosCliente.celular,
        marca: productoObtenido.datosProducto.marca,
        anio: productoObtenido.datosProducto.anio,
        modelo: productoObtenido.datosProducto.modelo,
        clase: productoObtenido.datosProducto.clase,
        tipo: productoObtenido.datosProducto.tipo,
        rastreo: productoObtenido.datosProducto.rastreoSatelital,
        nombre: productoObtenido.datosCliente.nombre,
        fechaNacimiento: productoObtenido.datosCliente.fechaNacimiento,
        estadoCivil: productoObtenido.datosCliente.codigoEstadoCivil,
        genero: productoObtenido.datosCliente.codigoGenero,
        territorioSeleccionado: productoObtenido.datosCliente.codigoTerritorio,
        territorioSeleccionadoComparador: null,
        formEditado: false,
        valorAsegurado: productoObtenido.datosProducto.valorAsegurado,
        valorAseguradoOriginal: productoObtenido.datosProducto.valor_avaluoOriginal,
        arrayTerritorios:
          productoObtenido.datosProducto.datosAccesorios.accesorios,
        arrayTerritoriosComparador:
          this.props.provinciasComparador,
        accesoriosHabilitado:
          parseInt(
            productoObtenido.datosProducto.datosAccesorios.valorAccesorios
          ) > 0
            ? true
            : false,
        selectedOption:
          productoObtenido.datosProducto.datosAccesorios.accesorios,
        selectedOptionColores: productoObtenido.datosProducto.color,
        valorAccesorios:
          productoObtenido.datosProducto.datosAccesorios.valorAccesorios,
        arrayAccesorios: [],
        arrayColores: [],
        hasValorAccesoriosError: true,
        cedulaError: "",
        celularError: "",
        hasColorError: false,
        arrayTipos: productoObtenido.datosProducto.arrayTipos,
        amparoGastosMedicosCheked: true,
        amparoAccidentesPersonalesCheked: true,
        amparoGastosTransporteCheked: productoObtenido && productoObtenido.datosProducto && productoObtenido.datosProducto.amparos && productoObtenido.datosProducto.amparos.gastosTransporte
          ? productoObtenido.datosProducto.amparos.gastosTransporte : false,
        amparoPatrimonialCheked: productoObtenido && productoObtenido.datosProducto && productoObtenido.datosProducto.amparos && productoObtenido.datosProducto.amparos.amparoPatrimonial ?
          productoObtenido.datosProducto.amparos.amparoPatrimonial : false,
        amparoObjetosOlvidadosCheked: productoObtenido && productoObtenido.datosProducto && productoObtenido.datosProducto.amparos && productoObtenido.datosProducto.amparos.objetosOlvidados ?
          productoObtenido.datosProducto.amparos.objetosOlvidados : false,
        amparoGastosFunerariosCheked: productoObtenido && productoObtenido.datosProducto && productoObtenido.datosProducto.amparos && productoObtenido.datosProducto.amparos.gastosFunerarios ?
          productoObtenido.datosProducto.amparos.gastosFunerarios : false,
        amparoAutoSustitutoCheked: true,
        amparoLlaveProtegidaCheked: true,
        amparoDocumentosProtegidosCheked: true,
        capacidad: productoObtenido.datosProducto.capacidad,
      });

      this.props.setDatosPlaca(productoObtenido.datosProducto);
      this.props.setDatosPersona(productoObtenido.datosCliente);
      //console.log("PRODUCOOOOOO ", productoObtenido)
      this.props.listarCoberturas(
        productoObtenido.datosCliente.codigoTerritorio
      );
      //Listar los Amparos Adicionales por default
      const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
      this.props.listarAmparosAdicionales(
        productoObtenido.datosCliente.codigoTerritorio,
        codEspecial
      );
      this.props.setPorcentajeExtras(
        productoObtenido.datosCliente.codigoTerritorio,
        codEspecial == 'comparador' || 'pits' ? true : false
      );
    }
    //Obtener Producto cuando no es edicion para obtener Deducibles
    let placacotizada = this.props.datosCotizacion.datosPlaca.placa;
    let arrayProductos1 = this.props.dataProductoCarrito.productosCarrito
      .carProductos;
    let productoObtenido1 = arrayProductos1.filter(
      (producto) => producto.datosProducto.placa === placacotizada
    );




    productoObtenido1 = productoObtenido1[0];
    this.props.setDatosPlaca(productoObtenido1.datosProducto); //Actualizar la informacion de la placa
    //cargar el valor de capacidad
    this.setState({ capacidad: productoObtenido1.datosProducto.capacidad });
    //console.log("productoObtenido1",productoObtenido1)
    //cargar array de deducibles
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles.deducibles
    ) {
      //Crear array de deducibles
      this.props.deduciblesRolesDatos.deduciblesRoles.deducibles.forEach(
        (element) => {
          const elemento = {
            id: element.valor,
            name: element.valor,
          };
          arrayDeducibles.push(elemento);
        }
      );
    }



    if (this.props.planesComparador.length == 0 && (this.state.codigoProductoEspecial == 'comparador' || this.state.codigoProductoEspecial == 'pits' || this.state.codigoProductoEspecial == 'externo')) {
      this.setState({ formEditado: true })
      this.onClick(productoObtenido1, true)
    }
    if (
      productoObtenido1 !== null &&
      productoObtenido1.datosCalculoScoring.deducible
    ) {
      this.setState({
        deducibleSelected: productoObtenido1.datosCalculoScoring.deducible,
      });
    }
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles.responsabilidadCivil
    ) {
      //Crear array de responsabilidad civil
      this.props.deduciblesRolesDatos.deduciblesRoles.responsabilidadCivil.forEach(
        (element) => {
          const elemento = {
            id: element.valor,
            name: element.valor,
          };
          arrayRc.push(elemento);
        }
      );
    }
    if (
      productoObtenido1 !== null &&
      productoObtenido1.datosCalculoScoring.limiteRC
    ) {
      this.setState({
        rcSelected: productoObtenido1.datosCalculoScoring.limiteRC,
      });
    }
    // ----Fin deducibles y responsabilidad civil
    //verificar permisos de deducible para roles
    if (
      this.props.deduciblesRolesDatos !== undefined &&
      this.props.deduciblesRolesDatos.deduciblesRoles.permisos
    ) {
      if (
        this.props.datosUsuarios !== undefined &&
        this.props.datosUsuarios.usu_tipo_usuario
      ) {
        let permisoUsuarioObtenido = this.props.deduciblesRolesDatos.deduciblesRoles.permisos.filter(
          (permiso) =>
            permiso.tipoUsuario === this.props.datosUsuarios.usu_tipo_usuario
        );
        permisoUsuarioObtenido = permisoUsuarioObtenido[0];
        if (
          permisoUsuarioObtenido !== undefined &&
          permisoUsuarioObtenido.puedeCambiarDeducible &&
          permisoUsuarioObtenido.puedeCambiarDeducible === "true"
        ) {
          this.setState({
            verDeducibles: true,
          });
        } else {
          /* this.setState({
            deducibleSelected: null,
          }); */
        }
        if (
          permisoUsuarioObtenido !== undefined &&
          permisoUsuarioObtenido.puedeCambiarResponsabilidadCivil &&
          permisoUsuarioObtenido.puedeCambiarResponsabilidadCivil === "true"
        ) {
          this.setState({
            verRc: true,
          });
        } else {
          /*  this.setState({
             rcSelected: null,
           }); */
        }
      }
    }
    //-----Fin verificar permisos de deducible para roles
    //Obtener el porcentaje extra de
    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
    this.props.setPorcentajeExtras(
      this.props.catalogoCotizacion.territorioDefault,
      codEspecial == 'comparador' || 'pits' ? true : false
    );

    //Listar las coberturas por default
    //console.log("listarCoberturas ", this.props.catalogoCotizacion.territorioDefault)
    this.props.listarCoberturas(
      this.props.catalogoCotizacion.territorioDefault
    );
    //Listar los Amparos Adicionales por default
    //console.log("listarAmparosAdicionales ", this.props.catalogoCotizacion.territorioDefault)
    this.props.listarAmparosAdicionales(
      this.props.catalogoCotizacion.territorioDefault,
      codEspecial
    );
    /*
        let arrayTerritorios = [
          {
            id: 1,
            name: "Cuenca y Austro"
          }
        ];*/

    let arrayTerritorios = Array.isArray(this.state.arrayTerritorios) ? this.state.arrayTerritorios.slice() : [];
    var arrayTerritoriosComparador = Array.isArray(this.state.arrayTerritoriosComparador) ? this.state.arrayTerritoriosComparador.slice() : [];



    this.props.catalogoCotizacion.territorios.forEach((element) => {
      const elemento = {
        id: element.ciuCodigoCore,
        name: element.ciuNombre,
        provCodigoCore: element.provCodigoCore,
        paiCodigoCore: element.paiCodigoCore,
      };
      arrayTerritorios.push(elemento);
    });

    arrayTerritoriosComparador = []

    if (Array.isArray(this.props.provinciasComparador)) {
      this.props.provinciasComparador.forEach((element) => {
        const elemento = {
          id: element.provCodigoCore,
          value: element.provCodigoCore,
          name: element.label,
          label: element.label,
          provCodigoCore: element.provCodigoCore,
          //paiCodigoCore: element.paiCodigoCore,
        };
        arrayTerritoriosComparador.push(elemento);





      });
    }






    var territorioDefault = arrayTerritoriosComparador.find(v => v.id == this.props.datosCotizacion.datosPersona.codigoTerritorio)
    if (this.props.datosCotizacion && this.props.datosCotizacion.datosPersona && this.props.datosCotizacion.datosPersona.codigoTerritorio && accion === "editar") {
      territorioDefault = arrayTerritoriosComparador.find(v => v.id == this.props.datosCotizacion.datosPersona.codigoTerritorio)

    }
    if (territorioDefault) {
      console.log('territorioDefault', territorioDefault)
      this.listarCiudades(territorioDefault.provCodigoCore, null)
      this.setState({
        territorioSeleccionadoComparadorAsegurado: territorioDefault
      })
    }

    if (territorioDefault) {
      this.setState({
        territorioSeleccionadoComparador: territorioDefault
      })
    }

    this.setState({ arrayTerritorios: arrayTerritorios });
    this.setState({ arrayTerritoriosComparador: arrayTerritoriosComparador });

    //----
    let arrayTipos = Array.isArray(this.state.arrayTipos) ? this.state.arrayTipos.slice() : [];

    if (this.props.datosCotizacion && this.props.datosCotizacion.datosPlaca && this.props.datosCotizacion.datosPlaca.arrayTipos) {

      this.props.datosCotizacion.datosPlaca.arrayTipos.forEach((element) => {
        const elemento = {
          id: element.id,
          name: element.name,
        };
        arrayTipos.push(elemento);
      });
      this.setState({ arrayTipos: arrayTipos });

    }


    //--
    let arrayAccesorios = this.state.arrayAccesorios.slice();

    this.props.catalogoCotizacion.accesorios.forEach((element) => {
      const elemento = {
        value: element.accCodigoCore,
        label: element.accNombre,
      };
      arrayAccesorios.push(elemento);
    });
    this.setState({ arrayAccesorios: arrayAccesorios });

    let arrayColores = this.state.arrayColores.slice();

    this.props.catalogoCotizacion.colores.forEach((element) => {
      const elemento = {
        value: element.colCodigoCore,
        label: element.colNombre,
      };
      arrayColores.push(elemento);
    });
    this.setState({ arrayColores: arrayColores });

    //Agregado para mostrar los totales en la cabecera
    let datosJSON = {
      empresa: "AIGMETROPOLITANA",
      plataforma: "WEB",
      idCarrito: this.props.dataProductoCarrito.productosCarrito.idCarrito,
    };
    await this.props.datosFacturacion(datosJSON);


    if (this.props.dataFacturacion && this.props.dataFacturacion.descuentoSeleccionado) {

      this.setState({
        descSelected: this.props.dataFacturacion.descuentoSeleccionad
      })

    }
    //Cargar Totales de la cabecera
    if (
      this.props.dataFacturacion !== undefined &&
      this.props.dataFacturacion !== ""
    ) {
      let param = {
        pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera
          ? this.props.dataFacturacion.pathIconoTotalesCabecera
          : "",
        totalItems: this.props.dataFacturacion.numItemsCarrito
          ? this.props.dataFacturacion.numItemsCarrito
          : "0",
        totalPrima:
          this.props.dataFacturacion.carValoresTotales &&
            this.props.dataFacturacion.carValoresTotales.primaTotal
            ? this.props.dataFacturacion.carValoresTotales.primaTotal
            : "0.00",
        ramoCotizador: this.props.dataFacturacion.carDescripcionRamo
          ? this.props.dataFacturacion.carDescripcionRamo
          : "",
      };
      await this.props.actualizarTotalesCabecera(param);




      if (this.props.dataFacturacion && this.props.dataFacturacion.descuentosBroker && this.props.dataFacturacion.descuentosBroker.productosDescuentos) {



        if (Array.isArray(this.props.dataFacturacion.descuentosBroker.productosDescuentos)) {

          let arrayDescuentos = []

          this.props.dataFacturacion.descuentosBroker.productosDescuentos.forEach(
            (element) => {
              const elemento = {
                id: element.value,
                name: element.label,
              };
              arrayDescuentos.push(elemento);
            }

          )
          this.setState({ descuentos: arrayDescuentos })
        }

      }
    }

    /*this.props.catalogoCotizacion.accesorios.forEach(element => {
      const elemento={
        value:element.accCodigoCore,
        label:element.accNombre
      }
      arrayAccesorios.push(elemento)
      
    });
    this.setState({arrayAccesorios:arrayAccesorios})*/

    /*
        let error=false;
    
        console.log("formulario continuar")
    
        let datosPlaca = this.props.datosCotizacion.datosPlaca;
        
    
        if(this.state.accesoriosHabilitado){
    
          if(this.state.selectedOption===null || this.state.selectedOption.length===0){
            error=true;
          }
          else{
            const datosAccesorios={
              accesorios:this.state.selectedOption,
              valorAccesorios:this.state.valorAccesorios
            }
            datosPlaca.datosAccesorios=datosAccesorios;
          }
    
        }
        else
        {
          
          const datosAccesorios={
            accesorios:[],
            valorAccesorios:0
          }
          datosPlaca.datosAccesorios=datosAccesorios;
        }
    
        console.log("formulario continuar des accesorios ",this.state.accesoriosHabilitado)
    
        if(!error ){
          delete datosPlaca.arrayMarcas;
          delete datosPlaca.marcaSeleccionada;
          delete datosPlaca.arrayModelos;
          delete datosPlaca.modeloSeleccionado;
          datosPlaca.anio=this.state.anio;
          datosPlaca.chasis=this.state.chasis;
          datosPlaca.rastreoSatelital=this.state.rastreo;
          datosPlaca.valorAsegurado = this.state.valorAsegurado;
    
    
          this.props.setDatosPlaca(datosPlaca);
    
    
    
          let datosPersona = this.props.datosCotizacion.datosPersona;
          datosPersona.codigoTerritorio=this.state.territorioSeleccionado
          this.props.setDatosPersona(datosPersona);
    
          const datosCarrito={
            empresa:"AIGMETROPOLITANA",
            plataforma:"WEB",
            cliCodigoCore:"",
            datosProducto:datosPlaca,
            datosCliente:this.props.datosCotizacion.datosPersona,
            datosCoberturas:[],
            datosAmparos:[],
            placa:datosPlaca.placa,
            accion:"agregar"
          }
    
          const datosCarritoJSON=JSON.stringify(datosCarrito);
          console.log("Enviar carrtio ",datosCarritoJSON)
    
          this.props.modificarCarrito(datosCarrito);
    
        }*/

    console.log("BeforeProps", this.props.productosCarrito);
    this.obtenerPlanesKmPaquete();


    if (
      (this.props.datosRenovaciones && this.props.datosRenovaciones.renovacionSeleccionada && this.props.datosRenovaciones.renovacionSeleccionada.dataTransformada)
    ) {
      let renovacionSeleccionada = this.props.datosRenovaciones.renovacionSeleccionada.dataTransformada

      this.setState({
        renovacionSeleccionada: renovacionSeleccionada,
        bloquearCarta: !renovacionSeleccionada.procesadoCorreoNoS
      })
    } else {
      this.setState({
        renovacionSeleccionada: null,
        bloquearCarta: false
      })
    }


    this.onClick(productoObtenido1, true)


    setTimeout(() => {
      this.setState({ mostrarTablaCoberturas: true });
    }, 1000);
  }


  /**
   * Función para validar chasis
   * chasis ingresado por el usuario
   *  */
  validarChasis = async (chasis) => {

    const { datosCotizacion, } = this.props;

    if (chasis == '' && datosCotizacion.datosPlaca.placa === "") {
      return this.setState({
        chasisValido: true
      })
    }

    if (this.state.placa === "" && (chasis == '' || !chasis)) {

      console.log('vervalidai', chasis, this.state.placa)
      this.setState({
        chasisValido: true
      })
    } else {
      var url = urlValidarChasis + chasis;
      const response = await fetch(url)
      const json = await response.json()

      if (json.transaccion) {

        this.setState({
          chasisValido: true
        })

      } else {
        this.setState({
          chasisValido: false
        })

      }
    }
  }

  /**
  * Función para validar motor
  * motor ingresado por el usuario
  *  */
  validarMotor = async (motor) => {

    const { datosCotizacion, } = this.props;

    if (motor == '' && datosCotizacion.datosPlaca.placa === "") {
      return this.setState({
        motorValido: true
      })
    }

    console.log('validacionMotor', motor)

    if ((this.state.placa === "") && motor == '') {


      this.setState({
        motorValido: true
      })
    } else {
      var url = urlValidarMotor + motor;
      const response = await fetch(url)
      const json = await response.json()

      if (json.transaccion) {

        this.setState({
          motorValido: true
        })

      } else {
        this.setState({
          motorValido: false
        })

      }
    }

  }

  obtenerPlanesKmPaquete = () => {
    let selectedplan = null;
    const arrayProductos = this.props.dataProductoCarrito.productosCarrito
      .carProductos;
    //console.log("productos", arrayProductos[0]);
    //var PlanesKmPaquete = null;
    var PlanesKmPaquete = arrayProductos[0].PlanesKmPaquete;
    if (PlanesKmPaquete !== undefined && PlanesKmPaquete !== null && PlanesKmPaquete !== '' && PlanesKmPaquete.length > 0) {
      const plan = arrayProductos[0].datosCalculoScoring.plan;
      PlanesKmPaquete = PlanesKmPaquete.slice(2, PlanesKmPaquete.length);//se pone para no mostrar en prod los 2 primeros productos
      this.setState({ planes: PlanesKmPaquete });
      console.log("plan", plan);
      PlanesKmPaquete.forEach((item) => {
        if (plan === item.codigo) {
          selectedplan = item;
        }
      });
    }
    if (selectedplan) {
      this.setState({ planSeleccionado: selectedplan });
    }

  };

  obtenerPlanComparador = () => {
    let selectedplan = null;
    const arrayProductos = this.props.dataProductoCarrito.productosCarrito
      .carProductos;



    if (this.state.vehiculoActual.rePlanSeleccionado) {
      const planEncontrado = this.props.planesComparador.find(plan => plan.codigo == this.state.vehiculoActual.rePlanSeleccionado)


      this.setState({ planComparadorSeleccionado: planEncontrado });


    }

  };


  openModal = (value) => {
    this.setState({ openModal: value });
  };
  handleChange = (selectedOption) => {



    // Obtener los accesorios originales
    const { selectedOptionOriginal } = this.state;

    // Filtrar los accesorios seleccionados para mantener solo los que estaban en los originales
    const accesoriosValidos = selectedOption.filter(accesorio =>
      selectedOptionOriginal.some(original => original.value === accesorio.value)
    );

    console.log('Accesorios originales:', selectedOptionOriginal);
    console.log('Accesorios originales 2', accesoriosValidos);
    console.log('Accesorios originales 3', selectedOption);
    // Actualizar el estado solo con los accesorios válidos
    this.setState({ selectedOption: accesoriosValidos });




    //console.log(`Option selected:`, selectedOption);
  };




  listarCiudades = async (provCodigoCore, ciudadPrecargada) => {



    let arrayProductos = this.props.dataProductoCarrito.productosCarrito
      .carProductos;
    let productoObtenido = arrayProductos.filter(
      (producto) => producto.datosProducto.placa === this.state.placa
    );

    productoObtenido = productoObtenido[0]

  

    let ciudad = null

    if (productoObtenido.datosAsegurado && productoObtenido.datosAsegurado.ciuCodigoCore) {
      ciudad = productoObtenido.datosAsegurado.ciuCodigoCore

    } else {

      ciudad = productoObtenido.datosAsegurado.ciudad.value


    }

    













    this.setState({
      ciudades: [],
      ciudadSeleccionada: null
    })

    await fetch(`${urlListarCiudades}${provCodigoCore}`)
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        if (data.transaccion) {
          let ciudades = data.ciudades;

          let arrayCiudades = [];
          let arrayCiudadesSelect = [];
          if (ciudades.length > 1)
            arrayCiudades.push({ id: "", name: "Seleccione la ciudad" });
          arrayCiudadesSelect.push({ id: "", name: "Seleccione la ciudad" });
          ciudades.forEach((element) => {
            const elemento = {
              id: element.ciuCodigoCore,
              name: element.ciuNombre,
              provCodigoCore: element.provCodigoCore,
            };
            arrayCiudades.push(elemento);

            const elemento2 = {
              value: element.ciuCodigoCore,
              label: element.ciuNombre,
              provCodigoCore: element.provCodigoCore,
            };
            arrayCiudadesSelect.push(elemento2);
          });

          var ciudadSeleccionada = null

          let placacotizada = this.props.datosCotizacion.datosPlaca.placa;
          let arrayProductos1 = this.props.dataProductoCarrito.productosCarrito
            .carProductos;
          let productoObtenido1 = arrayProductos1.filter(
            (producto) => producto.datosProducto.placa === placacotizada
          );

          productoObtenido1 = productoObtenido1[0]

          console.log('verDatosFacuracuin', this.props.datosCotizacion, productoObtenido1.datosAsegurado)

          let encontrada= null





          var ciudadEncontrada = null
          //  ciudadSeleccionada = ciudadEncontrada ? ciudadEncontrada : null

          console.log('verlugar', ciudad)

          arrayCiudadesSelect.forEach(ciudad2 => {

            if (ciudad == ciudad2.value){
              ciudadEncontrada=  ciudad2
          
            }
     
          });

          console.log('productoObtenido1121212323',ciudadEncontrada)





          this.setState({
            ciudades: arrayCiudadesSelect,
            ciudadSeleccionada: ciudadEncontrada
          })

   


        } else {

        }
      })

      .catch((response) => {

      });
  };


  handleChangeColores = (selectedOptionColores) => {
    this.setState({ selectedOptionColores });
    this.setState({ hasColorError: false });
    this.setState({ formEditado: true });

    //console.log(`Option selected colores:`, selectedOptionColores);
  };


  obtenerModificados = (inicial) => {

    let amparosOriginales = this.state.vehiculoActual.amparos;
    let amparosCarrito = this.props.datosCotizacion.datosPlaca.amparos
    let amarosModificados = this.state.coberturasAdicionalesComparadorModificados


    let amparosCarritoTotal = { ...amparosOriginales, ...amparosCarrito, ...amarosModificados }

    var amparosAux = {}
    var amparosAuxModificados = {}
    var amparosAuxFalse = {}

    this.state.coberturasAdicionalesComparador.forEach(element => {
      amparosAux[element.codigo] = true
    });

    if (this.state.planComparadorSeleccionado && this.state.planComparadorSeleccionado.coberturasAdicionales) {
      this.state.planComparadorSeleccionado.coberturasAdicionales.forEach(element => {
        var existe = this.state.coberturasAdicionalesComparador.find(cob => cob.codigo == element.codigo)
        if (!existe) {
          amparosAuxFalse[element.codigo] = false
        }
      });
    }


    var modificados = {}

    console.log('verPlaca11111', amparosCarrito)



    for (const i in amparosCarritoTotal) {

      modificados[i] = null

      console.log('verPlaca1', amarosModificados[i])



      // if(typeof amarosModificados[i] =='boolean'){

      if (true) {

        if (amparosAux[i] == true) {
          modificados[i] = true
        }

        if (amparosAuxFalse[i] == false) {
          modificados[i] = null
        }


      }









      if (amparosOriginales[i] == true) {
        modificados[i] = null

      }



    }


    return { ...modificados }


  }

  async cambiarValores(cedula) {
    await this.props.consultarCedula(cedula, false);
    if (this.props.datosCotizacion.consultarCedulaHasError) {
      this.setState({
        cedulaError: cedula,
      });
      this.setState({
        cedula: cedula,
        nombre: "",
        celular: "",
        formEditado: true,
      });
    } else {
      this.setState({
        nombre: this.props.datosCotizacion.datosPersona.nombre,
        celular: this.props.datosCotizacion.datosPersona.celular,
        fechaNacimiento: this.props.datosCotizacion.datosPersona
          .fechaNacimiento,
        estadoCivil: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,

        genero: this.props.datosCotizacion.datosPersona.codigoGenero,
        formEditado: true,
      });

      if (this.state.mismosDatos) {
        this.setState({
          nombreAsegurado: this.props.datosCotizacion.datosPersona.nombre,
          celularAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.celularAsegurado,
          fechaNacimientoAsegurado: this.props.datosCotizacion.datosPersona
            .fechaNacimiento,
          estadoCivilAsegurado: this.props.datosCotizacion.datosPersona.codigoEstadoCivil,

          generoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoGeneroAsegurado,
        });
      }
    }
  }

  async cambiarValoresAsegurado(cedula) {

    await this.props.consultarCedula(cedula, true);
    if (this.props.datosCotizacion.consultarCedulaHasError) {
      this.setState({
        cedulaAseguradoError: cedula,
      });
      this.setState({
        cedulaAsegurado: cedula,
        nombreAsegurado: "",
        //  nombre: "",
        celularAsegurado: "",
        formEditado: true,
      });
    } else {
      this.setState({
        nombreAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.nombreAsegurado,
        celularAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.celularAsegurado,
        fechaNacimientoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado
          .fechaNacimientoAsegurado,
        estadoCivilAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoEstadoCivilAsegurado,

        generoAsegurado: this.props.datosCotizacion.datosPersonaAsegurado.codigoGeneroAsegurado,
        formEditado: true,
      });
    }
  }




  toggleValidating(validate) {
    this.setState({ validate });
  }
  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasContraseniaActualError,
      hasContraseniaNuevaError,
      hasConfirmacionError,
    } = this.state;

    if (
      !hasContraseniaActualError ||
      !hasContraseniaNuevaError ||
      !hasConfirmacionError
    ) {
      this.handleOnClick();
    }
  }

  handleChangeFile = (e) => {
    this.setState({
      formEditado: true
    })
    const files = e.target.files;
    if (files && files[0]) this.handleFile(files[0]);
    // fileInputRef.current.value = null;
  }

  /**
   * Procesamiento del archivo excel
   * @param {*} file archivo seleccionado
   */
  handleFile = (file /*:File*/) => {
    console.log('archivo', file)
    this.convertFileToBase64(file)



  }

  convertFileToBase64 = (file) => {
    const reader = new FileReader();

    // Cuando el archivo se ha leído correctamente, almacenamos el resultado en el estado
    reader.onloadend = () => {
      this.setState({
        archivoNoSiniestros: {
          name: file.name,
          size: file.size
        },
        archivoNoSiniestrosBase64: reader.result.split(',')[1] // Eliminamos la parte de "data:image/jpeg;base64," si es una imagen, por ejemplo.
      });

      this.subirArchivoS3(reader.result.split(',')[1])
    };

    // Si ocurre un error al leer el archivo, lo manejamos aquí
    reader.onerror = () => {
      this.setState({
        errorArchivoNoSiniestros: 'Error al leer el archivo.'
      });
    };

    // Leemos el archivo como una URL de datos (Base64)
    reader.readAsDataURL(file);
  };

  subirArchivoS3 = async (base64File) => {


    this.setState({
      isLoading: true,
    })






    const data = await apiPost2(urlSubirArchivoS3, { file: base64File })

    console.log('archivo', data)

    if (data.transaccion) {


      this.setState({
        urlArchivoNoSiniestros: data.url,
      })

    }





    this.setState({
      isLoading: false,
      isLoadingRenovaciones: false
    })




  }


  getTipoDocumentos() {
    const listadoTipoDocumentos = [
      { id: infoIds.codigoCedulaNum, name: "Cédula", personeria: 1 },
      //   { id: infoIds.codigoPasaporteNum, name: "Pasaporte", personeria: 1 },
      //{ id: 3, name: "Ruc", personeria: 1 }, //agregado para pruebas
    ];

    return listadoTipoDocumentos;
  }



  async obtenerRenovacion() {

    //return {transaccion: true}
    try {


      const url = `${urlListarRenovaciones}${this.props.datosUsuarios.brokerCodigo}&ambiente=${ambienteAplicacion}&ramo=VEH%C3%8DCULOS`;
      const response = await fetch(url, {
        method: 'POST', body: JSON.stringify(
          {
            "rangoFecha": "03-12-2020 | 03-12-2026",
            "filtrosAtributos": {
              "reIdCarrito": this.props.dataProductoCarrito.productosCarrito.idCarrito,
            }
          }
        )
      });

      if (!response.ok) {
        throw new Error('Error al obtener la siniestralidad. Intente nuevamente más tarde.');
      }

      const json = await response.json();
      return json;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return {
        transaccion: false,
        mensaje: 'Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.'
      };
    }
  }

  getTipoDocumentosAsegurado() {
    const listadoTipoDocumentos = [
      { id: infoIds.codigoCedulaNum, name: "Cédula", personeria: 1 },
      { id: infoIds.codigoRucNum, name: "Ruc", personeria: 1 }, //agregado para pruebas
      { id: infoIds.codigoPasaporteNum, name: "Pasaporte", personeria: 1 },

    ];

    return listadoTipoDocumentos;
  }

  onClick = async (productoObtenido10, inicial = false) => {





    if (!this.state.valorAseguradoRenovacionValido) {
      return false
    }

    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")

    await this.toggleValidating(true);
    this.setState({
      validateAsegurado: true
    })


    this.setState({
      validateAsegurado: true
    })
    const {
      validate,
      placa,
      chasis,
      motor,
      cedula,
      cedulaError,
      celular,
      celularError,
      marca,
      anio,
      modelo,
      tipo,
      rastreo,
      nombre,
      fechaNacimiento,
      fechaNacimientoAsegurado,
      estadoCivil,
      estadoCivilAsegurado,
      parentesco,
      genero,
      territorioSeleccionado,
      territorioSeleccionadoComparador,
      formEditado,
      valorAsegurado,
      tipoSeleccionado,
      accesoriosHabilitado,
      autoConcesionaria,
      selectedOption,
      selectedOptionColores,
      valorAccesorios,
      hasValorAccesoriosError,
      amparoGastosMedicosCheked,
      amparoAccidentesPersonalesCheked,
      amparoGastosTransporteCheked,
      amparoPatrimonialCheked,
      amparoObjetosOlvidadosCheked,
      amparoGastosFunerariosCheked,
      amparoAutoSustitutoCheked,
      amparoLlaveProtegidaCheked,
      amparoDocumentosProtegidosCheked,
      capacidad,
      deducibleSelected,
      rcSelected,
      descSelected,
      descuentos,
      mismosDatos,
      cedulaAsegurado,
      tipoDocumentoAsegurado,
      celularAsegurado,
      nombreAsegurado,
      generoAsegurado,
      validateAsegurado

    } = this.state;






    if (!mismosDatos) {
      if (
        !cedulaAsegurado || cedulaAsegurado.trim() == '' ||
        !celularAsegurado || celularAsegurado.trim() == '' ||
        !nombreAsegurado || nombreAsegurado.trim() == '' ||
        !tipoDocumentoAsegurado || tipoDocumentoAsegurado == '' ||
        !generoAsegurado || generoAsegurado == '' ||
        !parentesco || parentesco == ''

      ) {
        return false
      } else if (
        tipoDocumentoAsegurado == '1' &&
        cedulaAsegurado.length != 10

      ) {
        return false

      } else if (
        tipoDocumentoAsegurado == '2' &&
        cedulaAsegurado.length != 13

      ) {
        return false

      }

      else if (
        celularAsegurado.length < 7
      ) {
        return false

      }
    }

    let error = false;
    if (!formEditado && !inicial) {







      if (parseInt(productoObtenido10) < parseInt(this.state.primaMinima)) {

        /*   this.setState({
            tieneErrorPrimaMinima: true,
            mensajeErrorPrimaMinima: `La prima neta debe ser superior a $${formatearNumero(this.state.primaMinima)}.`,
          })
  
          return false */

      } else {
        this.setState({
          tieneErrorPrimaMinima: false,
          mensajeErrorPrimaMinima: '',
        })

      }




      console.log('vererrortrama1')
      if (!selectedOptionColores) {
        this.setState({ hasColorError: false });
      }







      if (
        selectedOptionColores !== undefined &&
        selectedOptionColores &&
        // validar limites motor y chasis

        this.state.motorValido &&
        this.state.chasisValido &&
        capacidad !== "" &&
        //  (tipoSeleccionado != "" )&&
        // (tipoSeleccionado != undefined) &&
        valorAsegurado !== "" &&
        (codEspecial != 'vehiculosKilometrosPaquete' || codEspecial == 'vehiculosKilometrosPaquete' && this.state.planSeleccionado)
      ) {


        let color = selectedOptionColores;
        if (typeof selectedOptionColores === "object") {
          color = selectedOptionColores.value.toString();
        }
        /*let valtipo=this.props.datosCotizacion.datosPlaca.tipo;
        if(this.props.datosCotizacion.datosPlaca.tipo === "")
        {*/
        let valtipo = tipoSeleccionado;
        let urlEnviar = "https://";
        if (ambienteAplicacion === "local") {
          urlEnviar = "http://";
        }
        urlEnviar =
          urlEnviar +
          window.location.host +
          "/resumen-cotizacion-renovacion?id=" +
          this.props.dataProductoCarrito.productosCarrito.idCarrito +
          "&paso=resumen" +
          "" +
          (this.state.codigoProductoEspecial != null
            ? "&codigoProductoEspecial=" + this.state.codigoProductoEspecial
            : "");
        const datosActualizarCarrito = {
          empresa: "AIGMETROPOLITANA",
          plataforma: "WEB",
          idcarrito: this.props.dataProductoCarrito.productosCarrito.idCarrito,
          placa: this.props.datosCotizacion.datosPlaca.placa,
          valoresActualizar: {
            motor: motor.toUpperCase(),
            chasis: chasis.toUpperCase(),
            color: color,
            tipo: valtipo,
            capacidad: capacidad,
          },
          url: urlEnviar,
        };
        const datosActualizarCarritoJSON = JSON.stringify(
          datosActualizarCarrito
        );
        console.log("datosActualizarCarrito " + datosActualizarCarritoJSON);
        const arrayProductos = this.props.dataProductoCarrito;
        await this.props.fetchGuardarDatosAdiconalesCarrito(
          datosActualizarCarrito,
          arrayProductos
        );
        this.props.history.push({
          pathname: "/resumen-cotizacion-renovacion",
          search:
            `?id=${this.props.dataProductoCarrito.productosCarrito.idCarrito}&paso=resumen` +
            "" +
            (this.state.codigoProductoEspecial != null
              ? "&codigoProductoEspecial=" + this.state.codigoProductoEspecial
              : ""),
          state: { textoBreadcrumbs: this.props.location.state && this.props.location.state.textoBreadcrumbs ? this.props.location.state.textoBreadcrumbs : "" }
        });
      } else if (

        selectedOptionColores === null ||
        selectedOptionColores === "" ||
        selectedOptionColores === undefined
      ) {

        this.setState({ hasColorError: false });
      }
      //this.props.history.replace("/resumen-cotizacion");
    } else {


      error = false;

      let datosPlaca = this.props.datosCotizacion.datosPlaca;

      datosPlaca.autoConcesionaria = autoConcesionaria
      datosPlaca.primaMinima = this.state.primaMinima

      if (accesoriosHabilitado) {
        if (selectedOption === null || selectedOption.length === 0) {
          error = false;
        } else {
          let valorExtras =
            (valorAsegurado * this.props.datosCotizacion.porcentajeExtras) /
            100;
          if (valorAccesorios === "" || valorAccesorios < 0) {
            error = true;
          } else if (valorAccesorios <= valorExtras) {
            const datosAccesorios = {
              accesorios: selectedOption,
              valorAccesorios: valorAccesorios,
            };
            datosPlaca.datosAccesorios = datosAccesorios;
          } else {
            error = false;
          }
        }
      } else {
        const datosAccesorios = {
          accesorios: [],
          valorAccesorios: 0,
        };
        datosPlaca.datosAccesorios = datosAccesorios;
      }

      if (
        (
          this.state.codigoProductoEspecial == "comparador" ||
          this.state.codigoProductoEspecial == "externo" ||
          this.state.codigoProductoEspecial == "pits" ||
          this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete"
        ) &&
        (
          !celular ||
          celular.trim() == "" ||
          celular.length < this.props.limitesVehiculos.limTelefono.valMin ||
          celular.length > this.props.limitesVehiculos.limTelefono.valMax
        )
      ) {
        //  error = true
      }

      if ((parseInt(this.state.tipoDocumento) == 3) && (this.state.fechaEmisionPasaporte == null || this.state.fechaCaducidadPasaporte == null || this.state.fechaIngresoPais == null)) {
        error = true
      }
      //console.log("formulario continuar des accesorios", accesoriosHabilitado, error)




      if (!error) {
        delete datosPlaca.arrayMarcas;
        delete datosPlaca.marcaSeleccionada;
        delete datosPlaca.arrayModelos;
        delete datosPlaca.modeloSeleccionado;
        datosPlaca.anio = anio;
        datosPlaca.chasis = chasis;
        datosPlaca.rastreoSatelital = rastreo;
        datosPlaca.valorAsegurado = valorAsegurado;
        datosPlaca.motor = motor;
        datosPlaca.capacidad = capacidad;
        datosPlaca.tipo = tipoSeleccionado;
        //Agregar parametrosde deducibles y responsabilidad civil
        datosPlaca.deducible = deducibleSelected;
        datosPlaca.rc = rcSelected;
        //Agregar array de Amparos Adicionales
        var ValorAmparosAdicionales = inicial ? this.props.datosCotizacion.datosPersona.amparosAux : {
          gastosMedicos: amparoGastosMedicosCheked,
          accidentesPersonales: amparoAccidentesPersonalesCheked,
          gastosTransporte: amparoGastosTransporteCheked,
          amparoPatrimonial: amparoPatrimonialCheked,
          objetosOlvidados: amparoObjetosOlvidadosCheked,
          gastosFunerarios: amparoGastosFunerariosCheked,
          amparoSustituto: amparoAutoSustitutoCheked,
          llaveProtegida: amparoLlaveProtegidaCheked,
          documentosProtegidos: amparoDocumentosProtegidosCheked,
        };
        datosPlaca.amparos = ValorAmparosAdicionales;

        this.props.setDatosPlaca(datosPlaca);

        let datosPersona = this.props.datosCotizacion.datosPersona;
        datosPersona.codigoTerritorio = territorioSeleccionado;
        const territorioObtenido = this.state.arrayTerritorios.filter(
          (modelo) => modelo.id === territorioSeleccionado
        );


        if (
          this.state.codigoProductoEspecial != "comparador" &&
          this.state.codigoProductoEspecial != "externo" &&
          this.state.codigoProductoEspecial != "pits" &&
          this.state.codigoProductoEspecial != "vehiculosKilometrosPaquete" &&
          this.state.codigoProductoEspecial != "KilometrosConsumidos"
        ) {
          datosPersona.provCodigoCore = territorioObtenido[0].provCodigoCore;
          datosPersona.paiCodigoCore = territorioObtenido[0].paiCodigoCore;
        }


        //ACTUALIZAR OBJETO DATOS PERSONA

        datosPersona.cedula =
          cedulaError !== undefined && cedulaError !== ""
            ? cedulaError
            : cedula;

        datosPersona.celular =
          celularError !== undefined && celularError !== ""
            ? celularError
            : celular;
        datosPersona.nombre = nombre;
        datosPersona.fechaNacimiento = fechaNacimiento;

        let obj = this.props.catalogoCotizacion.estadosCiviles.filter(
          (item) => item.id === parseInt(estadoCivil)
        );
        obj = obj[0];
        datosPersona.codigoEstadoCivil = estadoCivil;
        datosPersona.estadoCivil = obj.name;

        let obj1 = this.props.catalogoCotizacion.generos.filter(
          (item) => parseInt(item.id) === parseInt(genero)
        );
        obj1 = obj1[0];
        datosPersona.genero = obj1.name;
        datosPersona.codigoGenero = genero;

        this.props.setDatosPersona(datosPersona);

        let arrayProductos = this.props.dataProductoCarrito.productosCarrito
          .carProductos;


        let productoObtenido = arrayProductos.filter(
          (producto) => producto.datosProducto.placa === placa
        );

        ///////////

        let datosPersonaAsegurado = this.props.datosCotizacion.datosPersonaAsegurado;

        if (!datosPersonaAsegurado) {
          if (productoObtenido && productoObtenido[0]) {
            console.log('datosPersonaAsegurado', productoObtenido[0])
            if (productoObtenido[0].datosAsegurado) {
              datosPersonaAsegurado = productoObtenido[0].datosAsegurado
            }
          }
        }
        if (datosPersonaAsegurado) {

          datosPersonaAsegurado.codigoTerritorio = territorioSeleccionado;




          if (
            this.state.codigoProductoEspecial != "comparador" &&
            this.state.codigoProductoEspecial != "externo" &&
            this.state.codigoProductoEspecial != "pits" &&
            this.state.codigoProductoEspecial != "vehiculosKilometrosPaquete" &&
            this.state.codigoProductoEspecial != "KilometrosConsumidos"
          ) {
            datosPersonaAsegurado.provCodigoCore = territorioObtenido[0].provCodigoCore;
            datosPersonaAsegurado.paiCodigoCore = territorioObtenido[0].paiCodigoCore;
          }


          //ACTUALIZAR OBJETO DATOS PERSONA

          datosPersonaAsegurado.cedula =
            cedulaError !== undefined && cedulaError !== ""
              ? cedulaError
              : cedula;

          datosPersona.celular =
            celularError !== undefined && celularError !== ""
              ? celularError
              : celular;
          datosPersona.nombre = nombre;
          datosPersona.fechaNacimiento = fechaNacimiento;

          let obj2 = this.props.catalogoCotizacion.estadosCiviles.filter(
            (item) => item.id === parseInt(estadoCivilAsegurado)
          );
          obj = obj[0];
          datosPersonaAsegurado.codigoEstadoCivil = estadoCivilAsegurado;
          datosPersonaAsegurado.estadoCivil = obj2.name;

          let obj3 = this.props.catalogoCotizacion.generos.filter(
            (item) => parseInt(item.id) === parseInt(generoAsegurado)
          );
          obj3 = obj3[0];

          if (obj3 && obj3.name) {
            datosPersonaAsegurado.genero = obj3.name;
          }

          datosPersonaAsegurado.codigoGenero = generoAsegurado;

          this.props.setDatosPersonaAsegurado(datosPersonaAsegurado);

        }


        ///////////

        let fechaCalculoEdadAux = fechaNacimiento.split("/");
        let fechaCalculoEdad = `${fechaCalculoEdadAux[2]}-${fechaCalculoEdadAux[1]}-${fechaCalculoEdadAux[0]}`;
        //Validar Edad de las personas
        let banderaEdad = true;
        let hoy = new Date();
        let cumpleanos = new Date(fechaCalculoEdad);
        let edad = hoy.getFullYear() - cumpleanos.getFullYear();
        let m = hoy.getMonth() - cumpleanos.getMonth();
        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
          edad--;
        }


        let fechaCalculoEdadAuxAsegurado = fechaNacimientoAsegurado ? fechaNacimientoAsegurado.split("/") : new Date().toString("M/d/yyyy");
        let fechaCalculoEdadAsegurado = `${fechaCalculoEdadAuxAsegurado[2]}-${fechaCalculoEdadAuxAsegurado[1]}-${fechaCalculoEdadAuxAsegurado[0]}`;
        //Validar Edad de las personas
        let banderaEdadAsegurado = true;

        let hoyAsegurado = new Date();
        let cumpleanosAsegurado = new Date(fechaCalculoEdadAsegurado);
        let edadAsegurado = hoyAsegurado.getFullYear() - cumpleanosAsegurado.getFullYear();
        let mAsegurado = hoy.getMonth() - cumpleanosAsegurado.getMonth();
        if (mAsegurado < 0 || (mAsegurado === 0 && hoyAsegurado.getDate() < cumpleanosAsegurado.getDate())) {
          edadAsegurado--;
        }


        if (
          true
          /*        
                   edad >=
                   this.props.datosCotizacion.datosPersona.validacionesEdad
                     .valorMinimoEdad &&
                   edad <=
                   this.props.datosCotizacion.datosPersona.validacionesEdad
                     .valorMaximoEdad */
        ) {
        } else {
          banderaEdad = false;
          this.setState({ mostrarMensajeValidarEdad: true });
        }





        if (
          true
          /*  edad >=
           this.props.datosCotizacion.datosPersona.validacionesEdad
             .valorMinimoEdad &&
           edad <=
           this.props.datosCotizacion.datosPersona.validacionesEdad
             .valorMaximoEdad */
        ) {
        } else {
          banderaEdad = false;
          this.setState({ mostrarMensajeValidarEdad: true });
        }

        console.log('this.props.datosCotizacion.datosPersonaAsegurado', this.props.datosCotizacion.datosPersonaAsegurado)

        if (

          this.props.datosCotizacion &&
          this.props.datosCotizacion.datosPersonaAsegurado &&
          this.props.datosCotizacion.datosPersonaAsegurado.validacionesEdad &&
          this.props.datosCotizacion.datosPersonaAsegurado.validacionesEdad.valorMinimoEdad

        ) {

          const edadAux = mismosDatos ? edad : edadAsegurado

          if (
            edadAux >=
            this.props.datosCotizacion.datosPersonaAsegurado.validacionesEdad
              .valorMinimoEdad &&
            edadAux <=
            this.props.datosCotizacion.datosPersonaAsegurado.validacionesEdad
              .valorMaximoEdad
          ) {
          } else {
            banderaEdadAsegurado = false;
            this.setState({ mostrarMensajeValidarEdadAsegurado: true });
          }

        }




        //Fin Validar Edad de las personas
        if (
          valorAsegurado !== "" &&
          valorAsegurado > 0 &&
          nombre !== "" &&
          fechaNacimiento !== "" &&
          estadoCivil !== "" &&
          genero !== "" &&
          banderaEdad &&
          banderaEdadAsegurado
        ) {
          this.setState({
            formEditado: false,
          });

          var planSeleccionadoAux = null;

          const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")

          var amparosAux = {}
          var amparosAuxModificados = {}
          var amparosAuxFalse = {}




          if (codEspecial == 'comparador' || codEspecial == 'pits' || codEspecial == 'externo') {



            planSeleccionadoAux = this.state.planComparadorSeleccionado ? this.state.planComparadorSeleccionado.codigo : this.state.vehiculoActual.rePlanSeleccionado


            console.log('asasdasd', this.state.vehiculoActual.amparos)

            this.state.coberturasAdicionalesComparador.forEach(element => {
              amparosAux[element.codigo] = true

              if (!this.state.vehiculoActual.amparos[element.codigo]) {
                amparosAuxModificados[element.codigo] = true
              }



            });



            if (this.state.planComparadorSeleccionado && this.state.planComparadorSeleccionado.coberturasAdicionales) {

              this.state.planComparadorSeleccionado.coberturasAdicionales.forEach(element => {

                var existe = this.state.coberturasAdicionalesComparador.find(cob => cob.codigo == element.codigo)
                if (!existe) {
                  amparosAuxFalse[element.codigo] = false
                }
              });
            }



            ValorAmparosAdicionales = inicial ? this.props.datosCotizacion.datosPersona.amparosAux : this.state.planComparadorSeleccionado ? { ...ValorAmparosAdicionales, ...amparosAuxFalse, ...amparosAux } : productoObtenido10.datosCliente.amparosAux



          } else {
            planSeleccionadoAux = this.state.planSeleccionado != null
              ? this.state.planSeleccionado.codigo
              : "900"

          }

          var datosClienteAux = this.props.datosCotizacion.datosPersona;

          datosClienteAux.tipoDocumento = this.state.tipoDocumento

          if (this.state.fechaEmisionPasaporte && this.state.fechaCaducidadPasaporte && this.state.fechaIngresoPais) {
            datosClienteAux.fechaEmisionPasaporte = this.state.fechaEmisionPasaporte
            datosClienteAux.fechaCaducidadPasaporte = this.state.fechaCaducidadPasaporte
            datosClienteAux.fechaIngresoPais = this.state.fechaIngresoPais
          }



          if (codEspecial == 'comparador' || codEspecial == 'pits' || codEspecial == 'externo') {

            console.log('datosProducto2222', this.props.datosCotizacion.datosPersona.codigoTerritorio)
            datosClienteAux.codigoTerritorio = this.props.datosCotizacion.datosPersona.codigoTerritorio
            datosClienteAux.provCodigoCore = this.props.datosCotizacion.datosPersona.codigoTerritorio
            datosClienteAux.planAux = planSeleccionadoAux
            datosClienteAux.amparosAux = ValorAmparosAdicionales
            datosClienteAux.amparoMod = { ...ValorAmparosAdicionales, producto: codEspecial, recalcular: inicial ? false : true }

          }

          if (
            codEspecial == 'vehiculosKilometrosPaquete' ||
            codEspecial == 'KilometrosConsumidos'

          ) {
            const territorioEncontrado2 = this.state.arrayTerritoriosComparador.find(terr => terr.value == this.state.territorioSeleccionadoComparador.value)
            datosClienteAux.codigoTerritorio = territorioEncontrado2.provCodigoCore
            datosClienteAux.provCodigoCore = territorioEncontrado2.provCodigoCore
            datosClienteAux.amparosAux = ValorAmparosAdicionales
          }


          if (parentesco != '') {

            const parentescoEncontrado = this.props.catalogoCotizacion.parentescos.find(prt => prt.id == parentesco)
            if (parentescoEncontrado) {
              datosClienteAux.parCodigo = parentescoEncontrado.id
              datosClienteAux.parNombre = parentescoEncontrado.name

            } else {
              //   return false
            }


          } else {
            //  return false
          }

          var datosAseguradorAux = null;
          const edad = moment().diff(moment(this.state.fechaNacimientoAsegurado, 'DD/MM/YYYY'), 'years')

          if (this.state.mismosDatos) {

            datosAseguradorAux = { diferenteAConductor: false, mismosDatos: this.state.mismosDatos, ...datosClienteAux, edad: edad, ciudad: this.state.ciudadSeleccionada, provincia: this.state.territorioSeleccionadoComparadorAsegurado ? this.state.territorioSeleccionadoComparadorAsegurado : null }

          } else {


            const generoEncontrado = this.props.catalogoCotizacion.generos.find(gro => gro.id == this.state.generoAsegurado)

            const estadoCivilEncontrado = this.props.catalogoCotizacion.estadosCiviles.find(gro => gro.id == this.state.estadoCivilAsegurado)






            datosAseguradorAux = {
              diferenteAConductor: true,
              mismosDatos: this.state.mismosDatos,
              cedula: this.state.cedulaAsegurado,
              celular: this.state.celularAsegurado,
              nombre: this.state.nombreAsegurado,
              fechaNacimiento: this.state.fechaNacimientoAsegurado,
              edad: edad,
              estadoCivil: estadoCivilEncontrado.name,
              codigoEstadoCivil: this.state.estadoCivilAsegurado,
              genero: generoEncontrado.name,
              codigoGenero: this.state.generoAsegurado,
              codigoTerritorio: this.state.territorioSeleccionadoComparadorAsegurado ? this.state.territorioSeleccionadoComparadorAsegurado.value : null,
              provCodigoCore: this.state.territorioSeleccionadoComparadorAsegurad ? this.state.territorioSeleccionadoComparadorAsegurado.provCodigoCore : null,
              ciudad: this.state.ciudadSeleccionada,
              provincia: this.state.territorioSeleccionadoComparadorAsegurado ? this.state.territorioSeleccionadoComparadorAsegurado : null,
              paiCodigoCore: "1",
              urlArchivoNoSiniestros: this.state.urlArchivoNoSiniestros != '' ? this.state.urlArchivoNoSiniestros : null
            }
          }





          const datosCarrito = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            cliCodigoCore: this.props.dataProductoCarrito.productosCarrito
              .cliCodigoCore, //EnviarCodigoCore Persona creadora carrito
            datosProducto: datosPlaca,
            datosCliente: datosClienteAux,
            datosAsegurado: datosAseguradorAux,
            mismosDatos: this.state.mismosDatos,
            datosCoberturas: [],
            datosAmparos: [],
            recalcular: !inicial,
            amparos: codEspecial == 'comparador' || codEspecial == 'pits' || codEspecial == 'externo' ? ValorAmparosAdicionales : [],
            amparosAdicionalesModificados: this.obtenerModificados(inicial),
            placa: datosPlaca.placa,
            accion: "agregar",
            editar: true,
            carCodigo: this.props.dataProductoCarrito.productosCarrito
              .idCarrito,
            datosAsesor: {
              nombre: `${this.props.datosUsuarios.nombres} ${this.props.datosUsuarios.apellidos}`,
              codigoCore: this.props.datosUsuarios.cliCodigoCore,
              sucursalSeleccionada: this.props.datosSucursales
                .sucursalSelecionadaAsesor,
              ambiente: ambienteAplicacion,
            },
            esCotizacion: false,
            amparosAdicionales: ValorAmparosAdicionales,
            codigoProductoEspecial: this.state.codigoProductoEspecial,
            plan: planSeleccionadoAux,
            descuentoBroker: descSelected,
            numeroPoliza: parseInt(this.props.datosRenovaciones.renovacionSeleccionada.dataTransformada.numeroPolizaEmision),
            tasaScoring: inicial ? parseFloat(this.state.vehiculoActual.reTasaScoring) : parseFloat(this.state.vehiculoActual.reTasaScoringAnterior),
            tipoMod: true
          };

          console.log('this.props.datosRenovaciones', this.props.datosRenovaciones.renovacionSeleccionada.alldata.reDatosProducto.reDatosVehiculo[0].reTasaScoring)

          const datosCarritoJSON = JSON.stringify(datosCarrito);
          console.log("Enviar carrtio ", datosCarritoJSON);



            await this.props.modificarCarrito(datosCarrito);

          if (this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits" || this.state.codigoProductoEspecial == "externo") {
            this.obtenerPlanComparador()
          }


          this.setState({
            planesComparador: [],
          })

          this.setState({
            planesComparador: this.props.planesComparador,
            coberturasAdicionalesComparadorModificados: {}
          })


          var buscarSeleccionado = null

          if (this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits" || this.state.codigoProductoEspecial == "externo") {
            buscarSeleccionado = this.props.planesComparador.find(plan => plan.codigo == this.state.planComparadorSeleccionado ? this.state.planComparadorSeleccionado.codigo : null)
          }



          if (buscarSeleccionado) {
            this.setState({
              planComparadorSeleccionado: buscarSeleccionado
            })
          }




          this.props.listarCoberturas(
            this.props.datosCotizacion.datosPersona.codigoTerritorio
          );
          this.props.listarAmparosAdicionales(
            this.props.datosCotizacion.datosPersona.codigoTerritorio,
            codEspecial
          );

          //Agregado para mostrar los totales en la cabecera
          let datosJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            idCarrito: this.props.dataProductoCarrito.productosCarrito
              .idCarrito,
          };
          await this.props.datosFacturacion(datosJSON);
          //Cargar Totales de la cabecera
          if (
            this.props.dataFacturacion !== undefined &&
            this.props.dataFacturacion !== ""
          ) {
            let param = {
              pathIcono: this.props.dataFacturacion.pathIconoTotalesCabecera
                ? this.props.dataFacturacion.pathIconoTotalesCabecera
                : "",
              totalItems: this.props.dataFacturacion.numItemsCarrito
                ? this.props.dataFacturacion.numItemsCarrito
                : "0",
              totalPrima:
                this.props.dataFacturacion.carValoresTotales &&
                  this.props.dataFacturacion.carValoresTotales.primaTotal
                  ? this.props.dataFacturacion.carValoresTotales.primaTotal
                  : "0.00",
              ramoCotizador: this.props.dataFacturacion.carDescripcionRamo
                ? this.props.dataFacturacion.carDescripcionRamo
                : "",
            };
            await this.props.actualizarTotalesCabecera(param);
          }
        }
      }
    }
    console.log("After Update Props", this.props);
    this.obtenerPlanesKmPaquete();
  };
  planTemplate(plan) {
    return (
      <div className="car-details">
        <div className="p-grid p-nogutter">
          <div className="p-col-12"></div>
          <div className="p-col-12 car-data">
            <div className="car-title">{plan.descripcion}</div>
            <div className="car-subtitle">{plan.code} </div>

            <div className="car-buttons">
              <Button color="primary" onClick={() => this.onSelect(plan)}>
                Seleccionar
              </Button>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
  onSelect = (value) => {
    console.log("selected", value);

    if (value) {
      this.setState({
        planSeleccionado: value,
        formEditado: true,
      });
    }


  };


  onClickAtras = () => {

    this.props.history.goBack();
  }

  onEditarPlaca = (e) => {

    var search = `?accion=editarPlaca&editarPlaca=true`

    if (this.state.codigoProductoEspecial == "comparador") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=comparador'
    }

    if (this.state.codigoProductoEspecial == "externo") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=externo'
    }
    if (this.state.codigoProductoEspecial == "pits") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=pits'
    }
    if (this.state.codigoProductoEspecial == "vehiculosKilometrosPaquete") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=vehiculosKilometrosPaquete'
    }
    if (this.state.codigoProductoEspecial == "KilometrosConsumidos") {
      search = '?accion=editarPlaca&editarPlaca=true&codigoProductoEspecial=KilometrosConsumidos'
    }


    console.log('Redireccionar')
    this.props.history.push({
      pathname: "/cotizacion",
      search: search

    });
  }

  render() {
    const {
      validate,
      validateAsegurado,
      mismosDatos,
      placa,
      chasis,
      motor,
      cedula,
      cedulaAsegurado,
      nombreAsegurado,
      fechaNacimientoAsegurado,
      estadoCivilAsegurado,
      cedular,
      marca,
      anio,
      modelo,
      tipo,
      rastreo,
      nombre,
      fechaNacimiento,
      estadoCivil,
      parentesco,
      genero,
      generoAsegurado,
      territorioSeleccionado,
      territorioSeleccionadoComparador,
      territorioSeleccionadoComparadorAsegurado,
      ciudadSeleccionada,
      ciudades,
      formEditado,
      valorAsegurado,
      arrayTerritorios,
      arrayTerritoriosComparador,
      accesoriosHabilitado,
      autoConcesionaria,
      selectedOption,
      selectedOptionOriginal,
      selectedOptionColores,
      valorAccesorios,
      arrayAccesorios,
      arrayColores,
      hasValorAccesoriosError,
      cedulaError,
      cedulaAseguradoError,
      celularError,
      hasPlacaError,
      clase,
      hasColorError,
      tipoSeleccionado,
      arrayTipos,
      contadorCoberturas,
      amparoGastosMedicosCheked,
      amparoAccidentesPersonalesCheked,
      amparoGastosTransporteCheked,
      amparoPatrimonialCheked,
      amparoObjetosOlvidadosCheked,
      amparoGastosFunerariosCheked,
      amparoAutoSustitutoCheked,
      amparoLlaveProtegidaCheked,
      amparoDocumentosProtegidosCheked,
      capacidad,
      arrayDeducibles,
      deducibleSelected,
      arrayRc,
      rcSelected,
      descSelected,
      descuentos,
      verDeducibles,
      verRc,
      mostrarMensajeValidarEdad,
      mostrarMensajeValidarEdadAsegurado,
      bloquearCarta
    } = this.state;

    // codigo producto especial, para distinguir entre cotizadores de vehiculos
    const codEspecial = new URLSearchParams(this.props.location.search).get("codigoProductoEspecial")
    const anioActual = new Date().getFullYear()
    //console.log(this.state.validate, hasPlacaError);
    const { datosCotizacion, datosCoberturas, datosAmparos } = this.props;
    console.log("arrayColores ", this.props);
    let posicioncolor = 0;
    let i = 0;
    arrayColores.forEach(function (element) {
      if (element.value === parseInt(selectedOptionColores)) {
        posicioncolor = i;
      }
      i++;
    });
    if (posicioncolor === 0) {
      posicioncolor = undefined;
    }
    //Obtener Amparos Adicionales
    let ObtenerAmparoGastosMedicos = undefined;
    let ObtenerAmparoAccidentesPersonales = undefined;
    let ObtenerAmparoGastosTransporte = undefined;
    let ObtenerAmparoPatrimonial = undefined;
    let ObtenerAmparoObjetosOlvidados = undefined;
    let ObtenerAmparoGastosFunerarios = undefined;
    let ObtenerAmparoAutoSustituto = undefined;
    let ObtenerAmparoLlaveProtegida = undefined;
    let ObtenerAmparoDocumentosProtegidos = undefined;
    if (
      datosAmparos !== null &&
      datosAmparos !== undefined &&
      Object.keys(datosAmparos).length > 0
    ) {
      ObtenerAmparoGastosMedicos = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GM"
      );
      ObtenerAmparoAccidentesPersonales = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "AP"
      );
      ObtenerAmparoGastosTransporte = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GTR"
      );
      ObtenerAmparoPatrimonial = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "APAT"
      );
      ObtenerAmparoObjetosOlvidados = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "OOL"
      );
      ObtenerAmparoGastosFunerarios = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "GASTOS FUN"
      );
      ObtenerAmparoAutoSustituto = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "AUTOSUST"
      );
      ObtenerAmparoLlaveProtegida = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "LLAVEPROT"
      );
      ObtenerAmparoDocumentosProtegidos = datosAmparos.filter(
        (amparo) => amparo.cobNombre === "DOCPROT"
      );
    }

    let fechaNacimientoArray = new Date().toString("M/d/yyyy");
    if (fechaNacimiento) {
      fechaNacimientoArray = fechaNacimiento.split("/");
      fechaNacimientoArray =
        fechaNacimientoArray[2] +
        "/" +
        fechaNacimientoArray[1] +
        "/" +
        fechaNacimientoArray[0];
    }

    let fechaNacimientoAseguradoArray = new Date().toString("M/d/yyyy");
    if (fechaNacimientoAsegurado) {
      fechaNacimientoAseguradoArray = fechaNacimientoAsegurado.split("/");
      fechaNacimientoAseguradoArray =
        fechaNacimientoAseguradoArray[2] +
        "/" +
        fechaNacimientoAseguradoArray[1] +
        "/" +
        fechaNacimientoAseguradoArray[0];
    }

    let ValueCedula = cedula;
    if (this.props.datosCotizacion.consultarCedulaHasError) {
      // ValueCedula = cedulaError;
    }

    let ValueCedulaAsegurado = cedulaAsegurado;
    // if (this.props.datosCotizacion.consultarCedulaAseguradoHasError) {
    //   ValueCedulaAsegurado = cedulaAseguradoError;
    // }

    let editarMotor = false
    if (datosCotizacion.datosPlaca.motor === "" || datosCotizacion.datosPlaca.noSeEncontroInformacionAuto) {
      editarMotor = true
    }


    let editarChasis = false
    if (datosCotizacion.datosPlaca.chasis === "" || datosCotizacion.datosPlaca.noSeEncontroInformacionAuto) {
      editarChasis = true
    }





    //console.log("verRc",datosCotizacion.datosPlaca ,editarMotor,editarChasis)
    return (
      <LoadingScreen
        loading={
          this.props.datosCotizacion.consultarPlacaIsLoading ||
          this.props.datosCotizacion.consultarCedulaIsLoading ||
          this.props.dataProductoCarrito.isLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        <Page
          title={this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
            ? this.state.codigoProductoEspecial == "comparador" ? 'Renovación AIG AUTO' : 'Renovación PractiAuto'
            : "Renovación de vehículos"
          }

          breadcrumbs={[{
            name: this.state.codigoProductoEspecial == "comparador" || this.state.codigoProductoEspecial == "pits"
              ? this.state.codigoProductoEspecial == "comparador" ? 'Renovación AIG AUTO' : 'Renovación PractiAuto'
              : "Renovación de vehículos", active: true
          }]
          }
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div class="container-step">
                <div class="wrapper-step">
                  <div class="arrow-steps clearfix-step">
                    <div class="step current"> {`1. Cotización`} </div>
                    <div class="step"> {`2. Resumen`} </div>
                    <div class="step"> {`3. Confirmación`} </div>
                    <div class="step"> {` 4. Forma de Pago `} </div>
                    <div class="step"> {` 5. Formulario de Vinculación `} </div>
                    <div class="step"> {` 6. Emisión `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg={8}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
              <Card className="flex-row">
                <CardBody>

                  <h4 style={{ fontWeight: "bold" }}> Datos del Vehículo</h4>
                  <p />
                  <div style={styles.cardDatosVehiculo}>
                    <Row>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Marca:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.marca}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Modelo:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.modelo}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      {
                        (datosCotizacion.datosPlaca.placa && datosCotizacion.datosPlaca.placa != "") &&
                        <Col md={4}>
                          <Row>
                            <Col md={5}>
                              <span style={styles.tituloVehiculo}>
                                Placa:
                              </span>
                            </Col>
                            <Col md={7}>
                              <span style={styles.subTituloVehiculo}>
                                {datosCotizacion.datosPlaca.placa}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      }

                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Clase:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.clase}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Uso:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.tipo}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Row>
                          <Col md={5}>
                            <span style={styles.tituloVehiculo}>
                              Año:
                            </span>
                          </Col>
                          <Col md={7}>
                            <span style={styles.subTituloVehiculo}>
                              {datosCotizacion.datosPlaca.anio}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                  </div>





                  {((Array.isArray(selectedOptionOriginal) && selectedOptionOriginal.length > 0)) &&
                    <Row>
                      <Col lg={5} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>
                          {" "}
                          ¿El Vehículo posee Accesorios Adicionales?{" "}
                        </h5>
                        <p />
                      </Col>
                      <Col lg={1} md={6} sm={6} xs={12}>
                        <Checkbox
                          id={"accesorios"} // Optional.[String].Default: "".  Input ID.
                          name={"accesorios"} // Optional.[String].Default: "". Input name
                          classNameInputBox={'check-uber'}
                          disabled={false}
                          customStyleInputBox={{
                            backgroundColor: accesoriosHabilitado ? '#001871' : '#FFFFFF',
                            width: 20,
                            height: 20,
                          }}
                          //value={accesoriosHabilitado} // Required.[String].Default: "".
                          onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          checked={accesoriosHabilitado} // Required.[Bool].Default: false.
                          onChange={(accesoriosHabilitado, e) => {
                            this.setState({
                              accesoriosHabilitado,
                              formEditado: true,
                            });
                            //console.log(e);
                          }} // Required.[Func].Default: () => {}. Will return the value.
                          validationOption={{
                            name: "accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please check the .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Row>
                  }




                  {/*  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Marca</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.marca === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={marca}
                      />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Año</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.anio === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={anio}
                      />
                    </Col>
                  </Row> */}
                  {/*    <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Modelo</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.modelo === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={modelo}
                      />
                    </Col>
                  </Row> */}


                  {/* <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Clase</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>
                      <Textbox
                        tabIndex="1"
                        type="text"
                        id="test"
                        name="test"
                        classNameInput={
                          datosCotizacion.datosPlaca.clase === ""
                            ? "form-control"
                            : "input-type-label form-control"
                        }
                        value={clase}
                      />
                    </Col>
                  </Row> */}
                  {/*  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Uso</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      {this.props.datosCotizacion.datosPlaca.tipo === "v" && (
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="tipolabel"
                          name="tipolabel"
                          classNameInput={
                            datosCotizacion.datosPlaca.tipo === ""
                              ? "form-control"
                              : "input-type-label form-control"
                          }
                          value={datosCotizacion.datosPlaca.tipo}
                        />
                      )}
                      <Select1
                        id={"selectTipos"} // Optional.[String].Default: "". Input ID.
                        name={"selectTipos"} // Optional.[String].Default: "". Input name.
                        //value={datosCotizacion.datosPlaca.tipo!=="" ? datosCotizacion.datosPlaca.tipo :tipoSeleccionado} // Optional.[String].Default: "".
                        value={tipoSeleccionado} // Optional.[String].Default: "".
                        optionList={arrayTipos} // Required.[Array of Object(s)].Default: [].
                        onChange={(tipoSeleccionado, e) => {
                          this.setState({
                            tipoSeleccionado,
                            formEditado: true,
                          });
                          //console.log("tipoSeleccionado", tipoSeleccionado);
                        }} // Optional.[Func].Default: () => {}. Will return the value.
                        validate={validate}
                        validationCallback={(res) =>
                          //console.log(res)
                          this.setState({
                            hasTipoError: res,
                            validate: false,
                          })
                        }
                        classNameWrapper="bloquear-eventos-mouse"
                        classNameContainer="input-type-label padding-select-reactinputs" //Optional.[String].Default: "".
                        onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                        customStyleOptionListContainer={{}} // Optional.[Object].Default: {}.
                        validationOption={{
                          name: "selectTipos", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                          msgOnError:
                            "Por favor seleccione el uso de su vehículo",
                        }}
                      />
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      {datosCotizacion.datosPlaca.placa !== "" &&
                        <Textbox
                          ref={this.textInput}
                          tabIndex="1"
                          type="text"
                          id="test"
                          name="test"
                          classNameInput={
                            datosCotizacion.datosPlaca.placa === ""
                              ? "form-control"
                              : "input-type-label form-control"
                          }
                          value={placa}
                        />
                      }

                      {datosCotizacion.datosPlaca.placa === "" &&
                        <Button
                          className="btn btn-purple"
                          onClick={this.onEditarPlaca}
                          style={{ display: "block", margin: "0 0 0 auto" }}
                        >
                          <i className="fa fa-plus-circle" aria-hidden="true" /> INGRESAR PLACA
                        </Button>

                      }
                    </Col>
                  </Row> */}






                  {(Array.isArray(selectedOptionOriginal) && selectedOptionOriginal.length > 0) || valorAccesorios > 0 && (
                    <Row>


                      {Array.isArray(selectedOptionOriginal) &&
                        <Col lg={6} md={6} sm={6} xs={6}>
                          <Select
                            value={selectedOption}
                            //value={arrayAccesoriosSeleccionados}
                            components={makeAnimated()}
                            onChange={this.handleChange}
                            options={arrayAccesorios}
                            isSearchable={true}
                            placeholder={
                              "Seleccione los accesorios extra que posee su vehiculo. Ej: Radio"
                            }
                            isMulti={true}
                          />
                          {(selectedOption === null ||
                            selectedOption.length === 0) && (
                              <span style={{ color: "red", fontSize: "1rem" }}>
                                Por favor ingrese al menos un accesorio
                              </span>
                            )}
                        </Col>

                      }



                      <Col lg={3} md={3} sm={3} xs={3}>
                        <h5 style={{ fontWeight: "bold" }}>Valor accesorios</h5>
                      </Col>
                      <Col lg={3} md={3} sm={3} xs={3}>

                        {

                        }


                        {this.props.datosCotizacion.porcentajeExtras &&
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            disabled={true}
                            validate={validate}
                            type="text"
                            id="test"
                            name="test"
                            classNameInput="form-control"
                            placeholder="Ingrese valor ejemplo ($ 120.50)"
                            value={valorAccesorios}
                            onChange={(valorAccesorios, e) => {
                              this.setState({
                                valorAccesorios,
                                formEditado: true,
                              });
                              //console.log(e);
                            }}
                            validationCallback={(res) =>
                              //console.log(res)
                              this.setState({
                                hasValorAccesoriosError: res,
                                validate: false,
                              })
                            }
                            onBlur={(e) => {
                              this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }}
                            validationOption={{
                              name: "Valor accesorios", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: false,
                              customFunc: (res) => {
                                //Optional.[Func].Default: none. Custom function. Returns true or err message
                                let valorExtras =
                                  (valorAsegurado *
                                    this.props.datosCotizacion.porcentajeExtras) /
                                  100;
                                if (valorAccesorios < 0) {
                                  return "El valor ingresado debe ser positivo";


                                } else if (res === "0") {
                                  //console.log("Validando: ", res)
                                  return "El valor ingresado debe ser mayor a 0";
                                } else if (res === "") {
                                  return "Debe ingresar un valor numérico";
                                }

                                return true;
                              },
                            }}
                          />

                        }



                      </Col>
                    </Row>
                  )}



                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>

                      <h5 style={{ fontWeight: "bold" }}>Valor Asegurado</h5>
                    </Col>
                    <Col lg={3} md={6} sm={6} xs={12}>

                      <NumberFormat
                        className="form-control"
                        disabled={false}
                        value={valorAsegurado}
                        thousandSeparator={','}
                        decimalSeparator={'.'}
                        decimalScale={2}
                        prefix={''}
                        onValueChange={(valor, e) => {

                          const error = valor.floatValue >= this.props.limitesVehiculos.limAvaluo.valMin && valor.floatValue <= this.props.limitesVehiculos.limAvaluo.valMax






                          const valorOriginal = parseFloat(this.state.valorAseguradoOriginal)
                          const valorNuevo = valor.floatValue
                          const diezPorciento = valorOriginal * 10 / 100
                          const minimo = parseFloat(valorOriginal - diezPorciento)
                          const maximo = parseFloat(valorOriginal + diezPorciento)

                          console.log('valorwe3wq', valorOriginal, valorNuevo, diezPorciento, minimo, maximo)

                          if (valorNuevo < minimo || valorNuevo > maximo) {

                            this.setState({

                              valorAseguradoRenovacionValido: false,
                              valorAseguradoRenovacionValidoMensaje: `Se puede cotizar vehículos con un valor mínimo de $${formatearNumero(minimo)} y máximo de $${formatearNumero(maximo)}, que equivale al 10% de tolerancia`



                            });

                          }
                          else {

                            this.setState({

                              valorAseguradoRenovacionValido: true,
                              valorAseguradoRenovacionValidoMensaje: ``


                            });


                          }


                          this.setState({
                            valorAsegurado: valor.floatValue,
                            formEditado: true,
                            valorAseguradoValido: error

                          });


                        }}

                      />



                      {!this.state.valorAseguradoRenovacionValido && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          {this.state.valorAseguradoRenovacionValidoMensaje}
                        </span>
                      )}


                      {!this.state.valorAseguradoValido && (valorAsegurado === "" || valorAsegurado == undefined) && (
                        <span style={{ color: "red", fontSize: "1rem" }}>
                          Por favor ingrese el valor del avalúo.
                        </span>
                      )}
                      {/*  <Textbox
                        ref={this.textInput}
                        tabIndex="1"
                        type="text"
                        id="valorasegurado"
                        name="valorasegurado"
                        classNameInput="form-control"
                        value={valorAsegurado}

                        onChange={(valorAsegurado, e) => {
                          this.setState({
                            valorAsegurado,
                            formEditado: true,
                          });
                          //console.log("valorAsegurado0",valorAsegurado);
                        }}
                        onBlur={(e) => {
                          this.setState({ blur: true });
                          //console.log("BLUUUR");
                        }}

                        validationCallback={res => {

                          this.setState({
                            valorAseguradoValido: !res
                          })

                        }}

                        validationOption={{
                          // name: "Valor Asegurado", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                          check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                          required: true,
                          type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                          min: this.props.limitesVehiculos.limAvaluo.valMin, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                          max: this.props.limitesVehiculos.limAvaluo.valMax,
                          msgOnError: `El valor asegurado debe ser entre $${this.props.limitesVehiculos.limAvaluo.valMin} y $${this.props.limitesVehiculos.limAvaluo.valMax}`
                        }}
                      /> */}
                    </Col>

                  </Row>
                  {
                    datosCotizacion.datosPlaca.placa == "" &&
                    <Row>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        <h5 style={{ fontWeight: "bold" }}>Placa</h5>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={12}>
                        {datosCotizacion.datosPlaca.placa !== "" &&
                          <Textbox
                            ref={this.textInput}
                            tabIndex="1"
                            type="text"
                            id="test"
                            name="test"
                            classNameInput={
                              datosCotizacion.datosPlaca.placa === ""
                                ? "form-control"
                                : "input-type-label form-control"
                            }
                            value={placa}
                          />
                        }

                        {datosCotizacion.datosPlaca.placa === "" &&
                          <Button
                            className="btn btn-purple"
                            onClick={this.onEditarPlaca}
                            style={{ display: "block", margin: "0 0 0 auto" }}
                          >
                            <i className="fa fa-plus-circle" aria-hidden="true" /> INGRESAR PLACA
                          </Button>

                        }
                      </Col>
                    </Row>
                  }

                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Motor</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>


                      <h5>{motor}</h5>


                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={6} sm={6} xs={12}>
                      <h5 style={{ fontWeight: "bold" }}>Chasis</h5>
                    </Col>
                    <Col lg={9} md={6} sm={6} xs={12}>

                      <h5 >{chasis}</h5>




                    </Col>
                  </Row>















                </CardBody>
              </Card>




              {
                (codEspecial !== 'vehiculosKilometrosPaquete' &&
                  codEspecial !== 'comparador' &&
                  codEspecial !== 'externo' &&
                  codEspecial !== 'pits' &&
                  codEspecial !== 'KilometrosConsumidos'

                )
                && (
                  <Card className="flex-row ">
                    <CardBody>
                      <h4 style={{ fontWeight: "bold" }}>
                        {" "}
                        Coberturas Adicionales
                      </h4>
                      <div>
                        (Si deseas puedes añadir las siguientes coberturas para tu
                        póliza dando click en el botón "Agregar".)
                      </div>
                      <p />
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <ul class="a-container-gray">
                            {ObtenerAmparoGastosTransporte !== undefined &&
                              ObtenerAmparoGastosTransporte[0] !== undefined &&
                              ObtenerAmparoGastosTransporte[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoGastosTransporte[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoGastosTransporte[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoGastosTransporte"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoGastosTransporte"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          customStyleInputBox={{
                                            backgroundColor: amparoGastosTransporteCheked ? '#001871' : '#FFFFFF',
                                            width: 20,
                                            height: 20,
                                          }}
                                          checked={amparoGastosTransporteCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoGastosTransporteCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoGastosTransporteCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              {this.state.amparoGastosTransporteCheked ? 'Agregado' : 'Agregar'}
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoPatrimonial !== undefined &&
                              ObtenerAmparoPatrimonial[0] !== undefined &&
                              ObtenerAmparoPatrimonial[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {ObtenerAmparoPatrimonial[0].cobDescripcion}
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {ObtenerAmparoPatrimonial[0].cobDetalle}
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoPatrimonial"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoPatrimonial"} // Optional.[String].Default: "". Input name
                                          checked={amparoPatrimonialCheked} // Required.[Bool].Default: false.
                                          classNameInputBox={'check-uber'}
                                          customStyleInputBox={{
                                            backgroundColor: this.state.amparoPatrimonialCheked ? '#001871' : '#FFFFFF',
                                            width: 20,
                                            height: 20,
                                          }}


                                          onChange={(
                                            amparoPatrimonialCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoPatrimonialCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              {this.state.amparoPatrimonialCheked ? 'Agregado' : 'Agregar'}
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoObjetosOlvidados !== undefined &&
                              ObtenerAmparoObjetosOlvidados[0] !== undefined &&
                              ObtenerAmparoObjetosOlvidados[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoObjetosOlvidados[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoObjetosOlvidados[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoObjetosOlvidados"} // Optional.[String].Default: "".  Input ID.

                                          name={"amparoObjetosOlvidados"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          customStyleInputBox={{
                                            backgroundColor: amparoObjetosOlvidadosCheked ? '#001871' : '#FFFFFF',
                                            width: 20,
                                            height: 20,
                                          }}
                                          checked={amparoObjetosOlvidadosCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoObjetosOlvidadosCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoObjetosOlvidadosCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              {this.state.amparoObjetosOlvidadosCheked ? 'Agregado' : 'Agregar'}
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                            {ObtenerAmparoGastosFunerarios !== undefined &&
                              ObtenerAmparoGastosFunerarios[0] !== undefined &&
                              ObtenerAmparoGastosFunerarios[0] !== null && (
                                <li class="a-items">
                                  <input
                                    type="radio"
                                    name="amparogm"
                                    id="amparogm"
                                  />
                                  <label for="amparogm">
                                    {
                                      ObtenerAmparoGastosFunerarios[0]
                                        .cobDescripcion
                                    }
                                  </label>
                                  <div class="a-content-gray">
                                    <Row>
                                      <Col lg={9} md={9} sm={8} xs={12}>
                                        <p style={{ textAlign: "justify" }}>
                                          {
                                            ObtenerAmparoGastosFunerarios[0]
                                              .cobDetalle
                                          }
                                        </p>
                                      </Col>
                                      <Col lg={3} md={3} sm={4} xs={12}>
                                        <Checkbox
                                          id={"amparoGastosFunerarios"} // Optional.[String].Default: "".  Input ID.
                                          name={"amparoGastosFunerarios"} // Optional.[String].Default: "". Input name
                                          classNameInputBox={'check-uber'}
                                          customStyleInputBox={{
                                            backgroundColor: amparoGastosFunerariosCheked ? '#001871' : '#FFFFFF',
                                            width: 20,
                                            height: 20,
                                          }}
                                          checked={amparoGastosFunerariosCheked} // Required.[Bool].Default: false.
                                          onChange={(
                                            amparoGastosFunerariosCheked,
                                            e
                                          ) => {
                                            this.setState({
                                              amparoGastosFunerariosCheked,
                                              formEditado: true,
                                            });
                                            //console.log(e);
                                          }} // Required.[Func].Default: () => {}. Will return the value.
                                          labelHtml={
                                            <div style={{ background: "none" }}>
                                              {this.state.amparoGastosFunerariosCheked ? 'Agregado' : 'Agregar'}
                                            </div>
                                          } // Required.[Html].Default: none.
                                        />
                                      </Col>
                                    </Row>
                                  </div>
                                </li>
                              )}
                          </ul>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>)
              }
              {
                (codEspecial !== 'comparador' && codEspecial !== 'pits' && codEspecial !== 'externo') &&

                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }}> Coberturas</h4>
                    <p />
                    <Row>
                      {Object.keys(datosCoberturas).length > 0 &&
                        datosCoberturas.map((dCob, i) => {
                          return (
                            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                              <ul class="a-container">
                                <li class="a-items">
                                  <input type="radio" name="ac" id={"a" + i} />
                                  <label for={"a" + i}>
                                    {dCob.cobDescripcion}
                                  </label>
                                  <div class="a-content">
                                    <p style={{ textAlign: "justify" }}>
                                      {dCob.cobDetalle}
                                    </p>
                                  </div>
                                </li>
                              </ul>
                            </Col>
                          );
                        })}

                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoAutoSustituto !== undefined &&
                          ObtenerAmparoAutoSustituto[0] !== undefined &&
                          ObtenerAmparoAutoSustituto[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aAmpSusti" />
                                <label for="aAmpSusti">
                                  {ObtenerAmparoAutoSustituto[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoAutoSustituto[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoLlaveProtegida !== undefined &&
                          ObtenerAmparoLlaveProtegida[0] !== undefined &&
                          ObtenerAmparoLlaveProtegida[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aLlaveProt" />
                                <label for="aLlaveProt">
                                  {ObtenerAmparoLlaveProtegida[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoLlaveProtegida[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoDocumentosProtegidos !== undefined &&
                          ObtenerAmparoDocumentosProtegidos[0] !== undefined &&
                          ObtenerAmparoDocumentosProtegidos[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aDocProt" />
                                <label for="aDocProt">
                                  {
                                    ObtenerAmparoDocumentosProtegidos[0]
                                      .cobDescripcion
                                  }
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {
                                      ObtenerAmparoDocumentosProtegidos[0]
                                        .cobDetalle
                                    }
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoGastosMedicos !== undefined &&
                          ObtenerAmparoGastosMedicos[0] !== undefined &&
                          ObtenerAmparoGastosMedicos[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input type="radio" name="ac" id="aGMedicos" />
                                <label for="aGMedicos">
                                  {ObtenerAmparoGastosMedicos[0].cobDescripcion}
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {ObtenerAmparoGastosMedicos[0].cobDetalle}
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        {ObtenerAmparoAccidentesPersonales !== undefined &&
                          ObtenerAmparoAccidentesPersonales[0] !== undefined &&
                          ObtenerAmparoAccidentesPersonales[0] !== null && (
                            <ul class="a-container">
                              <li class="a-items">
                                <input
                                  type="radio"
                                  name="ac"
                                  id="aAccidentesPersonales"
                                />
                                <label for="aAccidentesPersonales">
                                  {
                                    ObtenerAmparoAccidentesPersonales[0]
                                      .cobDescripcion
                                  }
                                </label>
                                <div class="a-content">
                                  <p style={{ textAlign: "justify" }}>
                                    {
                                      ObtenerAmparoAccidentesPersonales[0]
                                        .cobDetalle
                                    }
                                  </p>
                                </div>
                              </li>
                            </ul>
                          )}
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              }
              {
                ((codEspecial === 'comparador' || codEspecial === 'pits' || codEspecial === 'externo') &&
                  this.state.planesComparador &&
                  this.state.planesComparador.length > 0


                )

                &&




                <Card>
                  <CardBody>


                    {
                      this.state.planComparadorSeleccionado &&
                      this.state.mostrarTablaCoberturas &&
                      <TablaCoberturasIndividual
                        vehiculoActual={this.state.vehiculoActual}
                        setPlanSeleccionadoMain={(plan) => {
                          this.setState({ planComparadorSeleccionado: plan, coberturasAdicionalesComparador: [], formEditado: true })
                        }}
                        valorAsegurado={this.state.valorAsegurado}
                        limiteAmparo={this.props.limitesVehiculos.limAmparo}
                        planSeleccionadoMain={this.state.planComparadorSeleccionado}
                        coberturasAdicionalesComparador={this.state.coberturasAdicionalesComparador}
                        coberturasAdicionalesComparadorModificados={this.state.coberturasAdicionalesComparadorModificados}
                        coberturasSeleccionadas={this.props.datosCotizacion.datosPersona.amparosAux}
                        codigoProductoEspecial={codEspecial}
                        esRenovacion={true}

                        setCoberturasAdicionalesComparador={(adicionales, actualizar) => {

                          console.log('adicionales', adicionales)


                          this.setState({
                            coberturasAdicionalesComparador: adicionales,
                            formEditado: actualizar
                          })
                        }}


                        setCoberturasAdicionalesComparadorModificados={(adicionales) => {








                          this.setState({
                            coberturasAdicionalesComparadorModificados: adicionales,
                          })
                        }}


                        planesComparador={this.state.planesComparador.sort(function (a, b) {
                          if (a.primaTotal < b.primaTotal) return 1;
                          if (b.primaTotal < a.primaTotal) return -1;
                          return 0;
                        })}
                      >

                      </TablaCoberturasIndividual>

                    }


                  </CardBody>
                </Card>



              }

              <Button
                className={
                  "btn btn-primary"
                }
                onClick={this.onClickAtras}
                disabled={false}
                style={{ display: "block", margin: "0", marginBottom: 20 }}>
                <i
                  className='fa fa-chevron-circle-left'
                  aria-hidden='true'
                />{" "}
                {"ATRÁS"}
              </Button>


            </Col>

            <Col
              lg={4}
              md={12}
              sm={12}
              xs={12}
              className="detalle-impuestos-box"
            >



              {/*        {
                (codEspecial === 'comparador' &&
                  this.state.planComparadorSeleccionado &&
                  this.state.planesComparador &&
                  this.state.planesComparador.length > 0) &&
                <ValoresCotizacionComparador
                  planSeleccionado={this.state.planComparadorSeleccionado}
                  formEditado={formEditado}

                  metodo={() => {
                    console.log('aqui estoy')
                    this.onClick()
                  }}
                >

                </ValoresCotizacionComparador>
              } */}





              <ValoresCotizacion
                key={1}
                formEditado={formEditado}
                tieneErrorPrimaMinima={this.state.tieneErrorPrimaMinima}
                mensajeErrorPrimaMinima={this.state.mensajeErrorPrimaMinima}
                primaMinima={this.state.primaMinima}
                paso={"datos-cotizacion"}
                metodo={this.onClick}
                placa={placa}
                planes={this.state.planes}
                planSeleccionado={codEspecial == 'comparador' || codEspecial == 'externo' || codEspecial == 'pits' ? this.state.planComparadorSeleccionado : this.state.planSeleccionado}
                codigoProductoEspecial={
                  this.state.codigoProductoEspecial != null ? true : false
                }
                codeProductoEspecial={this.state.codigoProductoEspecial}
                onSelect={this.onSelect}
              />
            </Col>
          </Row>
        </Page>

        <div>
          <Modal
            isOpen={this.state.openModal}
            toggle={() => this.openModal(false)}
          >
            <ModalHeader toggle={() => this.openModal(false)}>
              {this.state.planSeleccionado != null
                ? this.state.planSeleccionado.descripcion
                : ""}
            </ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="col">
                  <label>
                    <strong>Code: </strong>
                  </label>
                  <br />
                  <label>
                    <strong>Value1: </strong>
                  </label>
                </div>
                <div className="col">
                  <label>
                    {this.state.planSeleccionado != null
                      ? this.state.planSeleccionado.code
                      : ""}
                  </label>
                  <br />
                  <label>
                    {this.state.planSeleccionado != null
                      ? this.state.planSeleccionado.value1
                      : ""}
                  </label>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => this.openModal(false)}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  //userIsLoggedIn: state.datosUsuarios.dataUsuario.userIsLoggedIn,
  datosCotizacion: state.datosCotizacion,
  productosCarrito: state.productosCarrito,
  catalogoCotizacion: state.catalogosCotizacion,
  dataProductoCarrito: state.dataProductoCarrito,
  datosUsuarios: state.datosUsuarios.dataUsuario,

  datosSucursales: state.datosSucursales,
  datosCoberturas: state.catalogosCotizacion.coberturas,
  datosAmparos: state.catalogosCotizacion.amparosAdicionales,
  deduciblesRolesDatos: state.deduciblesRolesDatos,
  dataFacturacion: state.dataFacturacion.datosFacturacion,
  limitesVehiculos: state.dataParametros,
  planesComparador: state.dataPlanesComparador.planesComparador,
  provinciasComparador: state.dataTerritoriosComparador.territorios.provincias,
  provinciaComparadorDefault: parseInt(state.dataTerritoriosComparador.territorios.provinciaDefecto),
  datosRenovaciones: state.dataRenovaciones,
});

const mapDispatchToProps = (dispatch) => {
  return {
    consultarCedula: (cedula, esAsegurado) => dispatch(consultarCedulaFetch(cedula, esAsegurado)),
    setDatosPlaca: (datos) => dispatch(setConsultaPlaca(datos)),
    listarParentescos: (datos) => dispatch(listarParentescosFetch(datos)),
    modificarCarrito: (datos) => dispatch(FetchModificarCarritoRenovacion(datos)),
    setDatosPersona: (datos) => dispatch(setDatosPersona(datos)),
    setDatosPersonaAsegurado: (datos) => dispatch(setDatosPersonaAsegurado(datos)),
    limpiarDatosCotizacion: () => dispatch(limpiarDatosCotizacion2()),
    fetchGuardarDatosAdiconalesCarrito: (datos, array) =>
      dispatch(FetchGuardarDatosAdiconalesCarrito(datos, array)),
    listarCoberturas: (territorio) => dispatch(coberturasFetch(territorio)),
    listarAmparosAdicionales: (territorio, codEspecial) =>
      dispatch(AmparosAdicionalesFetch(territorio, codEspecial)),
    setPorcentajeExtras: (zona, esComparador) => dispatch(FetchPorcentajeExtras(zona, esComparador)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera: (param) =>
      dispatch(FetchTotalesCabeceraCotizadores(param)),
    consultarProvincias: (ramo, sucursal) => dispatch(listarProvinciasComparadorFetch(ramo, sucursal)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Cotizacion2)
);
